import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Input, Output, NgModule, Optional, ViewChild, HostListener } from '@angular/core';
import * as i9 from '@gsa-sam/layouts';
import { SdsHeaderComponent, SdsHeaderModule, SdsFooterModule } from '@gsa-sam/layouts';
import * as i1$3 from '@gsa-sam/shared';
import { SystemAlertConfig, LoginModalComponent, cookies, SemDVModalComponent, SystemConfigHeader, SharedSystemConfig, SemDvModule, SpotlightModule, TermsOfUseModule, SystemAlertsService, UserAccessService, SystemBusyService, SystemConfigFooter, FeedbackService } from '@gsa-sam/shared';
import * as i1$2 from 'ngx-bootstrap-icons';
import { NgxBootstrapIconsModule, caretDownFill, exclamationTriangle, x, arrowLeftSquare, arrowRightSquare, bell, pencilSquare, squareFill, grid, xCircle, arrowDownCircleFill, arrowUpCircleFill, chevronDown, chevronUp, chatLeftDots } from 'ngx-bootstrap-icons';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i2 from '@gsa-sam/components';
import { SDS_DIALOG_DATA, SdsCollapseModule, NavigationMode, SdsDialogModule, SDSAutocompletelConfiguration, SDSSelectedItemModel, SelectionMode, SdsToastModule, SdsAutocompleteModule, SdsToastSettings } from '@gsa-sam/components';
import * as i2$1 from '@gsa-sam/ngx-uswds-icons';
import { IconModule } from '@gsa-sam/ngx-uswds-icons';
import * as i5 from '@angular/router';
import { NavigationEnd, RoutesRecognized } from '@angular/router';
import { Subject, forkJoin, merge, iif } from 'rxjs';
import { Cookie } from 'ng2-cookies';
import { switchMap, map, scan, shareReplay, filter } from 'rxjs/operators';
import * as i3 from '@angular/forms';
import { UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SdsFormlyModule } from '@gsa-sam/sam-formly';
import * as i1$4 from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import * as i3$1 from 'ngx-toastr';
import { ToastrService, ToastrModule } from 'ngx-toastr';

class CmsSystemAlertService {
    constructor(http) {
        this.http = http;
    }
    setEnviroment(env) {
        this.API_UMBRELLA_URL = env.apiUrl;
    }
    getAlerts() {
        const url = `${this.API_UMBRELLA_URL}/alerts`;
        let op = this._options();
        return this.http.get(url, op);
    }
    converCMSAlertToAlert(cmsAlert) {
        let alert = {
            header: cmsAlert.content.title,
            date: cmsAlert.content.published,
            description: cmsAlert.content.description,
            displayDescription: false,
            alertId: cmsAlert.alertID.toString()
        };
        return alert;
    }
    _options() {
        const params = {};
        return {
            headers: {},
            params: params
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CmsSystemAlertService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CmsSystemAlertService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CmsSystemAlertService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }] });
class cmsAlert {
}
class cmsAlertContent {
}

class BadLoginModalComponent {
    constructor(locationStrategy, sdsDialogRef, data) {
        this.locationStrategy = locationStrategy;
        this.sdsDialogRef = sdsDialogRef;
        this.data = data;
    }
    ngOnInit() {
        sessionStorage.removeItem('badLogin');
        this.imageSource = this.locationStrategy.getBaseHref() + (this.data.assetsUrl || 'assets/img/trademark-logo-sam.svg');
    }
    close() {
        this.sdsDialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: BadLoginModalComponent, deps: [{ token: i1$1.LocationStrategy }, { token: i2.SdsDialogRef }, { token: SDS_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: BadLoginModalComponent, selector: "ng-component", ngImport: i0, template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img alt=\"sam logo\" [attr.src]=\"imageSource\" width=\"170\">\r\n</div>\r\n\r\n<div sds-dialog-title=\"Test Title\" class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\" id=\"sds-dialog-title-11\">\r\n  There was an issue with your login.gov credentials.\r\n</div>\r\n\r\n<div sds-dialog-content=\"Test Content\" class=\"sds-dialog-content--centered\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4\">\r\n    Select <strong>Sign In</strong>, and complete all required authentication steps. If you are still receiving this error, contact the <a href=\"https://www.fsd.gov\">Federal Service Desk</a> to review your account data.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button class=\"usa-button\" (click)=\"close()\">OK</button>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.SdsDialogTitleDirective, selector: "[sds-dialog-title], [sdsDialogTitle]", inputs: ["id"], exportAs: ["sdsDialogTitle"] }, { kind: "directive", type: i2.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: BadLoginModalComponent, decorators: [{
            type: Component,
            args: [{ template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img alt=\"sam logo\" [attr.src]=\"imageSource\" width=\"170\">\r\n</div>\r\n\r\n<div sds-dialog-title=\"Test Title\" class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\" id=\"sds-dialog-title-11\">\r\n  There was an issue with your login.gov credentials.\r\n</div>\r\n\r\n<div sds-dialog-content=\"Test Content\" class=\"sds-dialog-content--centered\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4\">\r\n    Select <strong>Sign In</strong>, and complete all required authentication steps. If you are still receiving this error, contact the <a href=\"https://www.fsd.gov\">Federal Service Desk</a> to review your account data.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button class=\"usa-button\" (click)=\"close()\">OK</button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.LocationStrategy }, { type: i2.SdsDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }] });

class BlockedLoginModalComponent {
    constructor(locationStrategy, sdsDialogRef, data) {
        this.locationStrategy = locationStrategy;
        this.sdsDialogRef = sdsDialogRef;
        this.data = data;
    }
    ngOnInit() {
        sessionStorage.removeItem('blockedLogin');
        this.imageSource = this.locationStrategy.getBaseHref() + (this.data.assetsUrl || 'assets/img/trademark-logo-sam.svg');
    }
    close() {
        this.sdsDialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: BlockedLoginModalComponent, deps: [{ token: i1$1.LocationStrategy }, { token: i2.SdsDialogRef }, { token: SDS_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: BlockedLoginModalComponent, selector: "ng-component", ngImport: i0, template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img [attr.src]=\"imageSource\" alt=\"sam logo\" width=\"170\">\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\"\r\n     id=\"sds-dialog-title-11\"\r\n     sds-dialog-title=\"Title\">\r\n  Access Denied\r\n</div>\r\n\r\n<div class=\"sds-dialog-content--centered margin-bottom-2\" sds-dialog-content=\"FSD\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4 margin-bottom-0\">\r\n    If you need access, contact the Federal Service Desk at FSD.gov.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-content--centered\" sds-dialog-content=\"Government system\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4\">\r\n    This is a U.S. General Services Administration Federal Government computer system that is\r\n    \"<strong>FOR OFFICIAL USE\r\n    ONLY.</strong>\" This system is subject to monitoring. Individuals found performing unauthorized\r\n    activities are\r\n    subject to disciplinary action including criminal prosecution.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button (click)=\"close()\" class=\"usa-button usa-button--base bg-base-lighter\">Close</button>\r\n\r\n  <span class=\"margin-left-1\">\r\n    <a href=\"https://www.fsd.gov\"><button class=\"usa-button\">Contact FSD.gov</button></a>\r\n  </span>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.SdsDialogTitleDirective, selector: "[sds-dialog-title], [sdsDialogTitle]", inputs: ["id"], exportAs: ["sdsDialogTitle"] }, { kind: "directive", type: i2.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: BlockedLoginModalComponent, decorators: [{
            type: Component,
            args: [{ template: "<div class=\"sds-dialog-section--centered margin-y-205\">\r\n  <img [attr.src]=\"imageSource\" alt=\"sam logo\" width=\"170\">\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\"\r\n     id=\"sds-dialog-title-11\"\r\n     sds-dialog-title=\"Title\">\r\n  Access Denied\r\n</div>\r\n\r\n<div class=\"sds-dialog-content--centered margin-bottom-2\" sds-dialog-content=\"FSD\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4 margin-bottom-0\">\r\n    If you need access, contact the Federal Service Desk at FSD.gov.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-content--centered\" sds-dialog-content=\"Government system\">\r\n  <p class=\"font-sans-md maxw-none line-height-sans-4\">\r\n    This is a U.S. General Services Administration Federal Government computer system that is\r\n    \"<strong>FOR OFFICIAL USE\r\n    ONLY.</strong>\" This system is subject to monitoring. Individuals found performing unauthorized\r\n    activities are\r\n    subject to disciplinary action including criminal prosecution.\r\n  </p>\r\n</div>\r\n\r\n<div class=\"sds-dialog-section--centered margin-top-2\">\r\n  <button (click)=\"close()\" class=\"usa-button usa-button--base bg-base-lighter\">Close</button>\r\n\r\n  <span class=\"margin-left-1\">\r\n    <a href=\"https://www.fsd.gov\"><button class=\"usa-button\">Contact FSD.gov</button></a>\r\n  </span>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$1.LocationStrategy }, { type: i2.SdsDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }] });

class SystemAlertComponent {
    constructor() {
        this.seeAllAlerts = new EventEmitter();
        this.detailsClicked = new EventEmitter();
        this.alertDismiss = new EventEmitter();
    }
    /**
     * Removes the alert from input alerts array
     * @param index - index of the alert in array to remove
     */
    onAlertClose(index) {
        const dismissedAlert = this.alerts[index];
        this.alerts.splice(index, 1);
        this.alertDismiss.emit(dismissedAlert);
    }
    /**
     * Fired when 'See All Alerts' button is clicked. Emits the seeAllAlerts event
     */
    onSeeAllAlertsClicked() {
        this.seeAllAlerts.emit();
    }
    /**
     * Fired when 'Show Details' for an alert is clicked. Emits the detailsClicked event
     * with the alert whose 'Show Details' link was clicked and toggles description view for
     * the alert
     * @param alert
     */
    onShowDetailsClicked(alert) {
        alert.displayDescription = !alert.displayDescription;
        this.detailsClicked.emit(alert);
    }
    /** On mobile view - hide/display list of alerts based on toggle button */
    onToggleAlertsClicked(alertsContent) {
        const isHidden = alertsContent.classList.contains('display-none');
        if (isHidden) {
            alertsContent.classList.remove('display-none');
        }
        else {
            alertsContent.classList.add('display-none');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SystemAlertComponent, selector: "layout-system-alert", inputs: { alerts: "alerts" }, outputs: { seeAllAlerts: "seeAllAlerts", detailsClicked: "detailsClicked", alertDismiss: "alertDismiss" }, ngImport: i0, template: "<div class=\"sds-alert--header usa-grid\">\r\n    <div class=\"sds-alert--container\">\r\n      <div class=\"sds-mobile-alert grid-row\">\r\n        <div class=\"grid-col-auto padding-top-1\">\r\n          <usa-icon [icon]=\"'exclamation-triangle'\" [class]=\"'sds-alert--header__icon-mobile'\" [size]=\"'3x'\"></usa-icon>\r\n        </div>\r\n\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"grid-row tablet:display-none\">\r\n            <div class=\"grid-col-fill\">\r\n              <div class=\"sds-alert--header__label\">\r\n                You have {{alerts.length}} new alerts\r\n              </div>\r\n              <div>\r\n                <a href=\"javascript:void(0)\" (click)=\"onToggleAlertsClicked(alertsContent)\"\r\n                  class=\"sds-alert--header__link simple-toggle\" aria-controls=\"collapseTarget\">\r\n                  Show / Hide Alerts\r\n                </a>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-auto\">\r\n              <button (click)=\"onToggleAlertsClicked(alertsContent)\"\r\n                aria-label=\"Show/Hide alerts\"\r\n                class=\"sds-button--circle usa-button bg-primary-lighter simple-toggle\" aria-controls=\"collapseTarget\">\r\n                <usa-icon [icon]=\"'caret-down-fill'\" [size]=\"'1x'\"></usa-icon>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div #alertsContent class=\"grid-row width-full display-none tablet:display-inline-block\" id=\"collapseTarget\">\r\n            <div class=\"grid-col-fill\">\r\n              <div class=\"grid-row\">\r\n                <ng-container\r\n                  [ngTemplateOutlet]=\"alerts && alerts.length == 1 ? singleAlert : multipleAlerts\"\r\n                  [ngTemplateOutletContext]=\"{$implicit: alerts}\"\r\n                >\r\n                </ng-container>\r\n              </div>\r\n            </div>\r\n            <div class=\"tablet:grid-offset-1 tablet:grid-col-auto tablet:display-none\">\r\n              <div>\r\n                <button class=\"usa-button usa-button bg-primary-lighter\" id=\"seeAllAlertsMobileBtn\"\r\n                  (click)=\"onSeeAllAlertsClicked()\">See All Alerts</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"grid-offset-1 grid-col-auto display-none tablet:display-inline-block\">\r\n          <button class=\"usa-button usa-button bg-primary-lighter margin-y-1\" id=\"seeAllAlertsTabletBtn\"\r\n            (click)=\"onSeeAllAlertsClicked()\">See All\r\n            Alerts</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <ng-template #multipleAlerts let-alerts>\r\n    <div *ngFor=\"let alert of alerts; let i = index;\" class=\"grid-col-12\" [attr.id]=\"'alert' + i\">\r\n      <div class=\"sds-alert--header__content grid-row\">\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"sds-alert--header__label margin-right-1\" [innerHTML]=\"alert.header\"></div>\r\n          <a (click)=\"onShowDetailsClicked(alert)\"\r\n            role=\"button\"\r\n            href=\"javascript:void(0)\" class=\"sds-alert--header__link\"\r\n            [attr.aria-expanded]=\"alert.displayDescription\"\r\n            [attr.aria-controls]=\"'alertDescription' + i\"\r\n            >\r\n            {{alert.displayDescription ? 'Hide Details' : 'Show Details'}}\r\n          </a>\r\n          <span class=\"sds-alert--header__date\">\r\n            {{alert.date | date: 'mediumDate'}}\r\n          </span>\r\n          <span\r\n            aria-live=\"polite\"\r\n            [attr.id]=\"'alertDescription' + i\"\r\n            [sdsCollapse]=\"!alert.displayDescription\"\r\n            [innerHTML]=\"alert.description\">\r\n          </span>\r\n        </div>\r\n        <div class=\"grid-offset-1 grid-col-auto\">\r\n          <button (click)=\"onAlertClose(i)\" [attr.id]=\"'alert'+ i + 'CloseBtn'\"\r\n            class=\"usa-button sds-button--circle usa-button bg-primary-lighter sds-alert--header__close simple-toggle\"\r\n            aria-label=\"Close Alert\" [attr.aria-controls]=\"'alert' + i\">\r\n            <usa-icon [icon]=\"'x'\"></usa-icon>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #singleAlert let-alerts>\r\n    <div class=\"grid-col-12\" id=\"alert0\">\r\n      <div class=\"sds-alert--header__content grid-row\">\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"sds-alert--header__label margin-right-1\" [innerHTML]=\"alerts[0].header\"></div>\r\n          <span class=\"sds-alert--header__date\">\r\n            {{alerts[0].date | date: 'mediumDate'}}\r\n          </span>\r\n          <span [innerHTML]=\"alerts[0].description\"></span>\r\n        </div>\r\n        <div class=\"grid-offset-1 grid-col-auto\">\r\n          <button (click)=\"onAlertClose(0)\" id=\"alert0CloseBtn\"\r\n            class=\"usa-button sds-button--circle usa-button bg-primary-lighter sds-alert--header__close simple-toggle\"\r\n            aria-label=\"Close Alert\" aria-controls=\"alert0\">\r\n            <usa-icon [icon]=\"'x'\"></usa-icon>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$1.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "directive", type: i2.CollapseDirective, selector: "[sdsCollapse]", inputs: ["sdsCollapse"], exportAs: ["sdsCollapse"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'layout-system-alert', template: "<div class=\"sds-alert--header usa-grid\">\r\n    <div class=\"sds-alert--container\">\r\n      <div class=\"sds-mobile-alert grid-row\">\r\n        <div class=\"grid-col-auto padding-top-1\">\r\n          <usa-icon [icon]=\"'exclamation-triangle'\" [class]=\"'sds-alert--header__icon-mobile'\" [size]=\"'3x'\"></usa-icon>\r\n        </div>\r\n\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"grid-row tablet:display-none\">\r\n            <div class=\"grid-col-fill\">\r\n              <div class=\"sds-alert--header__label\">\r\n                You have {{alerts.length}} new alerts\r\n              </div>\r\n              <div>\r\n                <a href=\"javascript:void(0)\" (click)=\"onToggleAlertsClicked(alertsContent)\"\r\n                  class=\"sds-alert--header__link simple-toggle\" aria-controls=\"collapseTarget\">\r\n                  Show / Hide Alerts\r\n                </a>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col-auto\">\r\n              <button (click)=\"onToggleAlertsClicked(alertsContent)\"\r\n                aria-label=\"Show/Hide alerts\"\r\n                class=\"sds-button--circle usa-button bg-primary-lighter simple-toggle\" aria-controls=\"collapseTarget\">\r\n                <usa-icon [icon]=\"'caret-down-fill'\" [size]=\"'1x'\"></usa-icon>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div #alertsContent class=\"grid-row width-full display-none tablet:display-inline-block\" id=\"collapseTarget\">\r\n            <div class=\"grid-col-fill\">\r\n              <div class=\"grid-row\">\r\n                <ng-container\r\n                  [ngTemplateOutlet]=\"alerts && alerts.length == 1 ? singleAlert : multipleAlerts\"\r\n                  [ngTemplateOutletContext]=\"{$implicit: alerts}\"\r\n                >\r\n                </ng-container>\r\n              </div>\r\n            </div>\r\n            <div class=\"tablet:grid-offset-1 tablet:grid-col-auto tablet:display-none\">\r\n              <div>\r\n                <button class=\"usa-button usa-button bg-primary-lighter\" id=\"seeAllAlertsMobileBtn\"\r\n                  (click)=\"onSeeAllAlertsClicked()\">See All Alerts</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"grid-offset-1 grid-col-auto display-none tablet:display-inline-block\">\r\n          <button class=\"usa-button usa-button bg-primary-lighter margin-y-1\" id=\"seeAllAlertsTabletBtn\"\r\n            (click)=\"onSeeAllAlertsClicked()\">See All\r\n            Alerts</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <ng-template #multipleAlerts let-alerts>\r\n    <div *ngFor=\"let alert of alerts; let i = index;\" class=\"grid-col-12\" [attr.id]=\"'alert' + i\">\r\n      <div class=\"sds-alert--header__content grid-row\">\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"sds-alert--header__label margin-right-1\" [innerHTML]=\"alert.header\"></div>\r\n          <a (click)=\"onShowDetailsClicked(alert)\"\r\n            role=\"button\"\r\n            href=\"javascript:void(0)\" class=\"sds-alert--header__link\"\r\n            [attr.aria-expanded]=\"alert.displayDescription\"\r\n            [attr.aria-controls]=\"'alertDescription' + i\"\r\n            >\r\n            {{alert.displayDescription ? 'Hide Details' : 'Show Details'}}\r\n          </a>\r\n          <span class=\"sds-alert--header__date\">\r\n            {{alert.date | date: 'mediumDate'}}\r\n          </span>\r\n          <span\r\n            aria-live=\"polite\"\r\n            [attr.id]=\"'alertDescription' + i\"\r\n            [sdsCollapse]=\"!alert.displayDescription\"\r\n            [innerHTML]=\"alert.description\">\r\n          </span>\r\n        </div>\r\n        <div class=\"grid-offset-1 grid-col-auto\">\r\n          <button (click)=\"onAlertClose(i)\" [attr.id]=\"'alert'+ i + 'CloseBtn'\"\r\n            class=\"usa-button sds-button--circle usa-button bg-primary-lighter sds-alert--header__close simple-toggle\"\r\n            aria-label=\"Close Alert\" [attr.aria-controls]=\"'alert' + i\">\r\n            <usa-icon [icon]=\"'x'\"></usa-icon>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #singleAlert let-alerts>\r\n    <div class=\"grid-col-12\" id=\"alert0\">\r\n      <div class=\"sds-alert--header__content grid-row\">\r\n        <div class=\"grid-col-fill\">\r\n          <div class=\"sds-alert--header__label margin-right-1\" [innerHTML]=\"alerts[0].header\"></div>\r\n          <span class=\"sds-alert--header__date\">\r\n            {{alerts[0].date | date: 'mediumDate'}}\r\n          </span>\r\n          <span [innerHTML]=\"alerts[0].description\"></span>\r\n        </div>\r\n        <div class=\"grid-offset-1 grid-col-auto\">\r\n          <button (click)=\"onAlertClose(0)\" id=\"alert0CloseBtn\"\r\n            class=\"usa-button sds-button--circle usa-button bg-primary-lighter sds-alert--header__close simple-toggle\"\r\n            aria-label=\"Close Alert\" aria-controls=\"alert0\">\r\n            <usa-icon [icon]=\"'x'\"></usa-icon>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { alerts: [{
                type: Input
            }], seeAllAlerts: [{
                type: Output
            }], detailsClicked: [{
                type: Output
            }], alertDismiss: [{
                type: Output
            }] } });

class SystemAlertModule {
    static forRoot(config) {
        return {
            ngModule: SystemAlertModule,
            providers: [
                { provide: SystemAlertConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertModule, declarations: [SystemAlertComponent], imports: [CommonModule,
            IconModule,
            SdsCollapseModule, i1$2.NgxBootstrapIconsModule], exports: [SystemAlertComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertModule, imports: [CommonModule,
            IconModule,
            SdsCollapseModule,
            NgxBootstrapIconsModule.pick({ caretDownFill, exclamationTriangle, x })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                        SdsCollapseModule,
                        NgxBootstrapIconsModule.pick({ caretDownFill, exclamationTriangle, x }),
                    ],
                    declarations: [
                        SystemAlertComponent,
                    ],
                    exports: [
                        SystemAlertComponent
                    ]
                }]
        }] });

class SystemBusyModalConfig {
}
class SystemBusyModalComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.title = 'Sign In is briefly unavailable due to high demand.';
        if (data.type === 'entity') {
            this.title = 'Entity registration is briefly unavailable due to high demand.';
        }
    }
    close() {
        this.dialogRef.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemBusyModalComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i2.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: SystemBusyModalComponent, selector: "system-busy-modal", ngImport: i0, template: "<div sds-dialog-title=\"\" class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\"\r\n  id=\"sds-dialog-title-11\">\r\n  {{title}}\r\n</div>\r\n<div sds-dialog-content=\"\" class=\"sds-dialog-content--centered sds-dialog-content\">\r\n  <div class=\"text-center padding-x-2 padding-y-2 font-sans-2xs line-height-sans-6 text-base\">\r\n    <p class=\"font-sans-md maxw-none line-height-sans-3\">\r\n      We are experiencing a high volume of site traffic at this time.\r\n    </p>\r\n    <p class=\"font-sans-md margin-bottom\">\r\n      For best results, come back <strong> before 9:00 AM ET or after 5:00 PM ET.</strong>\r\n    </p>\r\n    <p class=\"font-sans-md line-height-sans-1 margin-bottom\">\r\n      We are sorry for this inconvenience.\r\n    </p>\r\n  </div>\r\n</div>\r\n<div class=\"sds-dialog-section--centered\">\r\n  <button (click)=\"close()\" class=\"usa-button usa-button--base bg-base-lighter\">Close</button>\r\n</div>\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SystemBusyModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'system-busy-modal', template: "<div sds-dialog-title=\"\" class=\"sds-dialog-section--centered sds-dialog-title line-height-sans-3\"\r\n  id=\"sds-dialog-title-11\">\r\n  {{title}}\r\n</div>\r\n<div sds-dialog-content=\"\" class=\"sds-dialog-content--centered sds-dialog-content\">\r\n  <div class=\"text-center padding-x-2 padding-y-2 font-sans-2xs line-height-sans-6 text-base\">\r\n    <p class=\"font-sans-md maxw-none line-height-sans-3\">\r\n      We are experiencing a high volume of site traffic at this time.\r\n    </p>\r\n    <p class=\"font-sans-md margin-bottom\">\r\n      For best results, come back <strong> before 9:00 AM ET or after 5:00 PM ET.</strong>\r\n    </p>\r\n    <p class=\"font-sans-md line-height-sans-1 margin-bottom\">\r\n      We are sorry for this inconvenience.\r\n    </p>\r\n  </div>\r\n</div>\r\n<div class=\"sds-dialog-section--centered\">\r\n  <button (click)=\"close()\" class=\"usa-button usa-button--base bg-base-lighter\">Close</button>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: SystemBusyModalConfig, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i2.SdsDialogRef }] });

class SignInWorkflowService {
    constructor(dialog, systemBusyService, unleashToggleService) {
        this.dialog = dialog;
        this.systemBusyService = systemBusyService;
        this.unleashToggleService = unleashToggleService;
        this.enable_session_metrics_check = false;
    }
    ngOnInit() {
        //  this.enable_session_metrics_check = this.unleashToggleService.isEnabled('enable_session_metrics_check');
    }
    setEnviroment(enviroment) {
        this.systemBusyService.setEnviroment(enviroment);
    }
    setAssetsUrl(assetsUrl) {
        this.assetsUrl = assetsUrl;
    }
    signIn(type) {
        /**
         * the login dialog is opened immediately without
         * making the API calls to check session metrics
        **/
        const dialogObs = new Subject();
        this.unleashToggleService.isEnabledObservable('enable_session_metrics_check').subscribe((result) => {
            if (!result) {
                this.openLogin(dialogObs);
            }
            else {
                /**
                 * enable the session metrics check feature
                 */
                let userCountMaxObs;
                let activeUserObs;
                if (type === 'entity') {
                    userCountMaxObs = this.systemBusyService.getMaxRegistationCount();
                    activeUserObs = this.systemBusyService.getCurrentUserLegacyCount();
                }
                else {
                    userCountMaxObs = this.systemBusyService.getMaxUserCount();
                    activeUserObs = this.systemBusyService.getCurrentUserCount();
                }
                forkJoin([userCountMaxObs, activeUserObs])
                    .subscribe((res) => {
                    let userCountMaxObj = res[0][0];
                    let activeUserObj = res[1];
                    let userCountMax = parseInt(userCountMaxObj['configValue'].toString());
                    let activeUser = 0;
                    if (type === 'entity') {
                        activeUser = parseInt(activeUserObj['jbossConnections'].toString())
                            + parseInt(activeUserObj['wrapperConnections'].toString())
                            + parseInt(activeUserObj['statusTrackerConnections'].toString());
                    }
                    else {
                        activeUser = parseInt(activeUserObj['numberOfActiveSessions'].toString());
                    }
                    if (activeUser < userCountMax) {
                        this.openLogin(dialogObs);
                    }
                    else {
                        let dialog = this.dialog.open(SystemBusyModalComponent, { width: 'medium', alert: "info", data: { type: type } });
                        dialogObs.next(dialog);
                    }
                }, (error) => {
                    // If services call we should just allow login
                    this.openLogin(dialogObs);
                    console.error(error);
                });
            }
        });
        return dialogObs;
    }
    openLogin(dialogObs) {
        const dialog = this.dialog.open(LoginModalComponent, { width: 'medium', disableClose: true, data: { assetsUrl: this.assetsUrl } });
        dialogObs.next(dialog);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SignInWorkflowService, deps: [{ token: i2.SdsDialogService }, { token: i1$3.SystemBusyService }, { token: i1$3.UnleashToggleService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SignInWorkflowService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: SignInWorkflowService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.SdsDialogService }, { type: i1$3.SystemBusyService }, { type: i1$3.UnleashToggleService }] });

class HeaderHelpService {
    constructor(router, cmsService) {
        this.router = router;
        this.cmsService = cmsService;
        this.manual = false;
        this.fromComponent = new Subject();
        this.fromRouter = new Subject();
        this.commands = merge(iif(() => this.manual === true, this.fromComponent.asObservable(), this.fromRouter.asObservable())).pipe(switchMap((help) => this.getCMSContent(help.key, help.sectionType)), map((data) => ({ data })));
        this.state$ = this.commands.pipe(scan((state, command) => ({ ...state, ...command })), shareReplay(1));
    }
    getCMSContent(key, sectionType = 'Accordion') {
        return this.cmsService
            .pageContent(key)
            .pipe(map((res) => this.cmsService.formatSection(res.sections, sectionType)));
    }
    getRouteHelpData() {
        let routeData = {};
        const routeStack = [
            this.router.routerState.snapshot.root,
        ];
        while (routeStack.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const route = routeStack.pop();
            routeData = { ...routeData, ...route.data };
            routeStack.push(...route.children);
        }
        if (!!routeData.help && !!routeData.help?.key) {
            this.fromRouter.next({
                key: routeData.help.key,
                sectionType: routeData.help.sectionType,
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderHelpService, deps: [{ token: i5.Router }, { token: i1$3.CMSService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderHelpService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderHelpService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i5.Router }, { type: i1$3.CMSService }] });

class HeaderComponent {
    constructor(config, http, authService, locationStrategy, dialog, router, tabCommunicationService, activatedRoute, userAccessService, authUserService, signInWorkflowService, headerHelpService, cdr, cmsSystemAlertService) {
        this.config = config;
        this.http = http;
        this.authService = authService;
        this.locationStrategy = locationStrategy;
        this.dialog = dialog;
        this.router = router;
        this.tabCommunicationService = tabCommunicationService;
        this.activatedRoute = activatedRoute;
        this.userAccessService = userAccessService;
        this.authUserService = authUserService;
        this.signInWorkflowService = signInWorkflowService;
        this.headerHelpService = headerHelpService;
        this.cdr = cdr;
        this.cmsSystemAlertService = cmsSystemAlertService;
        this.spotlightEnabled = false;
        // @ViewChild(SplashModalComponent) modal: SplashModalComponent;
        this.signInButtonStyle = 'current';
        this.modelHeader = {
            secondaryLinks: [],
            navigationLinks: [],
            home: {
                text: 'SAM.gov',
                route: '/',
                // Commenting out for testing the userstory with trademark logo
                // logo: this.locationStrategy.getBaseHref() + 'assets/img/sam-logo.png',
                logo: '',
                id: 'home'
            }
        };
        this.alerts = [];
        this.hideUI = {
            alerts: false,
            primaryLinks: false,
            secondaryLinks: false,
            logo: false
        };
        if (config) {
            this.appEnv = config.environment;
            this.userAccessService.setEnvironment(config);
            cmsSystemAlertService.setEnviroment(config);
            this.signInWorkflowService.setEnviroment(config);
        }
    }
    setUpHeaderLinks(cmsSystemAlertService) {
        this.setAlerts(cmsSystemAlertService);
        this.setHeaderLinks();
        this.determineSecondaryLinks();
        this.setHeaderImage();
        if (this.pageId) {
            this.header.select(this.pageId);
            this.cdr.detectChanges();
        }
    }
    setAlerts(cmsSystemAlertService) {
        cmsSystemAlertService.getAlerts().subscribe((alertsResp) => {
            const alerts = [];
            const cookies = this.getCookies('alertsDismiss');
            alertsResp.forEach(alertResp => {
                const tempAlert = cmsSystemAlertService.converCMSAlertToAlert(alertResp);
                if (!cookies.includes(tempAlert.alertId.toString())) {
                    alerts.push(tempAlert);
                }
            });
            this.alerts = alerts;
        });
    }
    setHeaderLinks() {
        const CMSSystemName = 'CMS';
        this.modelHeader.navigationLinks.push({ text: 'Home', route: '/', id: 'home', systemName: CMSSystemName, mode: undefined }, { text: 'Search', route: '/search/', id: 'search', systemName: 'MFE-SEARCH', mode: undefined }, { text: 'Data Bank', route: '/reports/awards/standard', id: 'databank', systemName: 'SFE', mode: undefined }, { text: 'Data Services', route: '/data-services', id: 'dataService', systemName: 'SFE', mode: undefined }, { text: 'Help', route: '/help', id: 'help', systemName: CMSSystemName, mode: undefined });
        this.determineLinkSetup();
    }
    determineSecondaryLinks() {
        if (this.authService.isLoggedIn()) {
            this.userAccessService.getUserDetailsFromSession().subscribe(() => {
                const signTermsUrl = '/workspace/profile/sign-terms-of-use';
                if (document.location.pathname !== signTermsUrl) {
                    if (this.ignoredTermsRedirection === undefined || this.ignoredTermsRedirection.indexOf(document.location.pathname) === -1) {
                        //navigate
                        if (!this.authUserService.getIsUatSigned()) {
                            localStorage.setItem('sign-terms-key', document.location.href);
                            document.location.href = signTermsUrl;
                        }
                    }
                }
                const profileRegistration = '/login-gov/profile-registration';
                if (document.location.pathname !== profileRegistration && document.location.pathname !== signTermsUrl) {
                    if (!this.authUserService.getIsProfileComplete()) {
                        document.location.href = profileRegistration;
                    }
                }
                if (!this.authUserService.getIsTempProfile()) {
                    this.modelHeader.secondaryLinks.push({
                        imageClassPrefix: 'sds',
                        imageClass: 'pencil-square',
                        text: 'Requests',
                        route: '/workspace/profile/feeds',
                        id: 'request',
                        hasCounter: false,
                        systemName: 'MFE-ADMIN',
                        mode: undefined
                    }, {
                        imageClassPrefix: 'sds',
                        imageClass: 'bell',
                        text: 'Notifications',
                        route: '/workspace/profile/feeds/notification',
                        id: 'notifications',
                        systemName: 'MFE-ADMIN',
                        mode: undefined
                    }, {
                        imageClassPrefix: 'sds',
                        imageClass: 'grid',
                        text: 'Workspace',
                        route: '/workspace/profile/workspace',
                        id: 'workspace',
                        systemName: 'MFE-ADMIN',
                        mode: undefined
                    });
                    // Set links' navigation mode to internal or external and update the routes
                    this.modelHeader.secondaryLinks.forEach((link) => {
                        link['mode'] = link.systemName.toUpperCase() === this.appEnv.toUpperCase() ? NavigationMode.INTERNAL : NavigationMode.EXTERNAL;
                        if (link['mode'] === NavigationMode.INTERNAL) {
                            link['route'] = link['route'].replace(this.locationStrategy.getBaseHref(), '/');
                        }
                    });
                    this.getRequests().subscribe((res) => {
                        if (res && res.totalRecords > 0) {
                            this.modelHeader.secondaryLinks[0].hasCounter = true;
                        }
                    });
                }
                this.modelHeader.secondaryLinks.push({
                    imageClassPrefix: 'sds',
                    imageClass: 'arrow-right-square',
                    text: 'Sign Out',
                    route: '',
                    id: 'signOut',
                    systemName: 'login',
                    mode: NavigationMode.EVENT
                });
            }, () => {
                this.authService.signOutFrontendOnly();
            });
            // For Multitab communication for signin/signout
            this.tabCommunicationService.listen().subscribe({
                next: (message) => {
                    if (message == 'LOGOUT') {
                        this.authService.signOut();
                    }
                    else if (message == 'LOGIN') {
                        this.authService.signIn();
                    }
                }
            });
            /* Cookie added so that this api is only called once per user */
            let cookieValue = this.getCookies('isAlerted');
            let options = cookies();
            if (Cookie.get("isAlerted") !== "true" && !this.authUserService.getIsTempProfile()) {
                this.userAccessService.getPendingInvites().subscribe((res) => {
                    if (res && !res[0].alerted && res[0].role.val === 'Sensitive Entity Management Data Viewer') {
                        this.dialog.open(SemDVModalComponent, {
                            width: 'medium',
                            alert: 'info',
                            disableClose: true
                        });
                        this.userAccessService.onSemDvModalConfirm().subscribe((response) => {
                            Cookie.set('isAlerted', 'true', options.expires, options.path);
                        });
                    }
                });
            }
        }
        else {
            // current sign in button style
            if (this.signInButtonStyle == 'current')
                this.modelHeader.secondaryLinks.push({
                    imageClassPrefix: 'sds', imageClass: 'arrow-left-square', text: 'Sign In', route: '', id: 'signIn', systemName: 'SFE',
                    mode: NavigationMode.EVENT, styleClass: 'sign-in-button-current'
                });
            // new icon
            if (this.signInButtonStyle == 'icon') {
                this.modelHeader.secondaryLinks.push({
                    imageClassPrefix: 'sds', imageClass: 'group_8_login_gov_icon', text: 'Sign In', route: '', id: 'signIn', systemName: 'SFE',
                    mode: NavigationMode.EVENT, styleClass: 'sign-in-button-icon'
                });
            }
            // new icon and outline
            if (this.signInButtonStyle == 'iconAndOutline') {
                this.modelHeader.secondaryLinks.push({
                    imageClassPrefix: 'sds', imageClass: 'group_8_login_gov_icon', text: 'Sign In', route: '', id: 'signIn', systemName: 'SFE',
                    mode: NavigationMode.EVENT, styleClass: 'sign-in-button-outline'
                });
            }
        }
        ;
    }
    getCookies(cookie, separator = ',') {
        return (Cookie.get(cookie)).split(separator);
    }
    ngOnInit() {
        this.setUpHeaderLinks(this.cmsSystemAlertService);
        this.headerItemSelectedSetup();
        this.determineShowHideOfSections();
    }
    determineLinkSetup() {
        // If link's mode is undefined then set the navigation mode to internal or external and update the routes
        this.modelHeader.navigationLinks.forEach((link) => {
            if (link['mode'] === undefined) {
                link['mode'] = link.systemName.toUpperCase() === this.appEnv.toUpperCase() ? NavigationMode.INTERNAL : NavigationMode.EXTERNAL;
                if (link['mode'] === NavigationMode.INTERNAL) {
                    link['route'] = link['route'].replace(this.locationStrategy.getBaseHref(), '/');
                }
            }
        });
    }
    determineShowHideOfSections() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.hideUI.alerts = !!params['hideAlerts'];
            this.hideUI.primaryLinks = !!params['hidePrimaryLinks'];
            this.hideUI.secondaryLinks = !!params['hideSecondaryLinks'];
            this.hideUI.logo = !!params['hideLogo'];
        });
        const hideAlertsObs = this.getValueOutOfRouteData('hideAlerts');
        hideAlertsObs.subscribe((hideAlerts) => {
            if (hideAlerts) {
                this.hideUI.alerts = true;
            }
            else {
                this.hideUI.alerts = false;
            }
        });
        const hidePrimaryLinksObs = this.getValueOutOfRouteData('hidePrimaryLinks');
        hidePrimaryLinksObs.subscribe((hidePrimaryLinks) => {
            if (hidePrimaryLinks) {
                this.hideUI.primaryLinks = true;
            }
            else {
                this.hideUI.primaryLinks = false;
            }
        });
        const hideSecondaryLinksObs = this.getValueOutOfRouteData('hideSecondaryLinks');
        hideSecondaryLinksObs.subscribe((hideSecondaryLinks) => {
            if (hideSecondaryLinks) {
                this.hideUI.secondaryLinks = true;
            }
            else {
                this.hideUI.secondaryLinks = false;
            }
        });
        const hideLogoObs = this.getValueOutOfRouteData('hideLogo');
        hideLogoObs.subscribe((hideLogoObs) => {
            if (hideLogoObs) {
                this.hideUI.logo = true;
            }
            else {
                this.hideUI.logo = false;
            }
        });
    }
    headerItemSelectedSetup() {
        this.router
            .events.pipe(filter(event => event instanceof NavigationEnd), map((event) => {
            this.headerHelpService.state$.subscribe((res) => (this.helpData = res.data));
            this.headerHelpService.getRouteHelpData();
            let child = this.activatedRoute.firstChild;
            while (child) {
                if (child.firstChild && !child.snapshot.data['id']) {
                    child = child.firstChild;
                }
                else if (child.snapshot.data && child.snapshot.data['id']) {
                    return child.snapshot.data['id'];
                }
                else {
                    return null;
                }
            }
            return null;
        })).subscribe((id) => {
            this.pageId = id;
            this.header.select(id);
            // IAEDEV-49734: Temporary fix to solve the dummy session issue in the browser
            if (!this.authService.isLoggedIn()) {
                this.tabCommunicationService.channel.postMessage("LOGOUT");
                Cookie.delete('SESSION');
            }
        });
    }
    setHeaderImage() {
        if (typeof this.assetsUrl === 'undefined') {
            this.modelHeader.home.logo = this.locationStrategy.getBaseHref() +
                'assets/img/trademark-logo-sam.svg';
        }
        else {
            this.modelHeader.home.logo = this.locationStrategy.getBaseHref() +
                this.assetsUrl;
        }
    }
    getValueOutOfRouteData(dataName) {
        return this.router
            .events.pipe(filter(event => event instanceof NavigationEnd), map((event) => {
            let child = this.activatedRoute.firstChild;
            while (child) {
                if (child.firstChild && !child.snapshot.data[dataName]) {
                    child = child.firstChild;
                }
                else if (child.snapshot.data && child.snapshot.data[dataName]) {
                    return child.snapshot.data[dataName];
                }
                else {
                    return null;
                }
            }
            return null;
        }));
    }
    ngAfterViewInit() {
        // this.modal.openDialog(this.assetsUrl);
        // Show "bad login" modal if login data received from login.gov is corrupted somehow
        if (sessionStorage.getItem('badLogin'))
            this.dialog.open(BadLoginModalComponent, { width: 'medium', data: { assetsUrl: this.assetsUrl } });
        // Show "blocked login" modal if user is blocked from signing in at the Login Authenticator level
        if (sessionStorage.getItem('blockedLogin'))
            this.dialog.open(BlockedLoginModalComponent, { width: 'medium', data: { assetsUrl: this.assetsUrl } });
    }
    onLinkEvent($event) {
        if (!$event || !$event.id) {
            return;
        }
        if ($event.id === 'signIn') {
            this.signInWorkflowService.setAssetsUrl(this.assetsUrl);
            this.signInWorkflowService.signIn();
        }
        else if ($event.id === 'signOut') {
            this.authService.signOut();
            this.tabCommunicationService.channel.postMessage("LOGOUT");
        }
    }
    getRequests() {
        const random = new Date().getTime().toString();
        const apiKey = this.config.apiKey;
        const params = {
            random: random,
            feedTypeId: "2",
            limit: "1",
            statIds: "1"
        };
        if (!this.config.production) {
            const apiKey = this.config.apiKey;
            params["api_key"] = apiKey;
        }
        const headers = {
            'X-Auth-Token': this.authService.authToken()
        };
        const url = `${this.config.apiUrl}/feeds/v1/requests`;
        return this.http.get(url, { params, headers });
    }
    /*need to finlize the route*/
    onSeeAllAlerts() {
        window.location.href = '/alerts';
    }
    onShowDetailsClicked(alert) {
        // return the description
    }
    onAlertDismiss(alert) {
        let cookies = this.getCookies('alertsDismiss').toString();
        cookies = cookies ? cookies + ',' + alert.alertId : alert.alertId.toString();
        /* 10year of expiration date 356*10 */
        Cookie.set('alertsDismiss', cookies, 3650, '/', null, true);
    }
    skipNav() {
        document.getElementById('main-container').scrollIntoView();
        let currentX = window.pageXOffset || document.documentElement.scrollLeft;
        let currentY = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo(currentX, currentY - this.stickyBannerHeight);
        document.getElementById('main-container').setAttribute('tabindex', '0');
        document.getElementById('main-container').focus();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderComponent, deps: [{ token: i1$3.SystemConfigHeader, optional: true }, { token: i1.HttpClient }, { token: i1$3.AuthService }, { token: i1$1.LocationStrategy }, { token: i2.SdsDialogService }, { token: i5.Router }, { token: i1$3.TabCommunicationService }, { token: i5.ActivatedRoute }, { token: i1$3.UserAccessService }, { token: i1$3.AuthUserService }, { token: SignInWorkflowService }, { token: HeaderHelpService }, { token: i0.ChangeDetectorRef }, { token: CmsSystemAlertService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: HeaderComponent, selector: "layout-header", inputs: { spotlightEnabled: "spotlightEnabled", signInButtonStyle: "signInButtonStyle", ignoredTermsRedirection: "ignoredTermsRedirection", assetsUrl: "assetsUrl", flagPath: "flagPath" }, viewQueries: [{ propertyName: "header", first: true, predicate: SdsHeaderComponent, descendants: true }], ngImport: i0, template: "<a id=\"skipnav-link\" tabindex=\"0\" class=\"usa-skipnav\" role=\"link\" aria-label=\"Skip to main content on the same page\"\r\n  (click)=\"skipNav()\" (keyup.enter)=\"skipNav()\">Skip to main content</a>\r\n\r\n<sds-header #header [model]=\"modelHeader\" (linkEvent)=\"onLinkEvent($event)\" [alertsTemplate]=\"alertsTemplate\"\r\n  [showHeaderLogo]=\"!hideUI.logo\" [help]=\"helpData\" [hideSecondaryLinks]=\"hideUI.secondaryLinks\"\r\n  [hidePrimaryLinks]=\"hideUI.primaryLinks\" [hideAlerts]=\"hideUI.alerts\" [flagPath]=\"flagPath\">\r\n  <ng-template #spotlight>\r\n    <div *ngIf=\"spotlightEnabled\">\r\n      <div spotlight [spotlightId]=\"'0ee7d538-d179-4ce4-b160-4ca1fcbc744a'\" [position]=\"'RIGHT'\"></div>\r\n    </div>\r\n  </ng-template>\r\n\r\n</sds-header>\r\n\r\n<ng-template #alertsTemplate>\r\n  <layout-system-alert *ngIf=\"alerts && alerts.length\" [alerts]=\"alerts\" (seeAllAlerts)=\"onSeeAllAlerts()\"\r\n    (detailsClicked)=\"onShowDetailsClicked($event)\" (alertDismiss)=\"onAlertDismiss($event)\"></layout-system-alert>\r\n</ng-template>\r\n\r\n<!-- <terms-of-service></terms-of-service> -->", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i9.SdsHeaderComponent, selector: "sds-header", inputs: ["showTopBanner", "hideSecondaryLinks", "hidePrimaryLinks", "hideAlerts", "model", "flagPath", "topBannerDescription", "showHeaderLogo", "alertsTemplate", "help"], outputs: ["linkEvent"] }, { kind: "component", type: SystemAlertComponent, selector: "layout-system-alert", inputs: ["alerts"], outputs: ["seeAllAlerts", "detailsClicked", "alertDismiss"] }, { kind: "directive", type: i1$3.SpotlightDirective, selector: "[spotlight]", inputs: ["spotlightId", "position", "spotlightDisabled", "debug"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'layout-header', template: "<a id=\"skipnav-link\" tabindex=\"0\" class=\"usa-skipnav\" role=\"link\" aria-label=\"Skip to main content on the same page\"\r\n  (click)=\"skipNav()\" (keyup.enter)=\"skipNav()\">Skip to main content</a>\r\n\r\n<sds-header #header [model]=\"modelHeader\" (linkEvent)=\"onLinkEvent($event)\" [alertsTemplate]=\"alertsTemplate\"\r\n  [showHeaderLogo]=\"!hideUI.logo\" [help]=\"helpData\" [hideSecondaryLinks]=\"hideUI.secondaryLinks\"\r\n  [hidePrimaryLinks]=\"hideUI.primaryLinks\" [hideAlerts]=\"hideUI.alerts\" [flagPath]=\"flagPath\">\r\n  <ng-template #spotlight>\r\n    <div *ngIf=\"spotlightEnabled\">\r\n      <div spotlight [spotlightId]=\"'0ee7d538-d179-4ce4-b160-4ca1fcbc744a'\" [position]=\"'RIGHT'\"></div>\r\n    </div>\r\n  </ng-template>\r\n\r\n</sds-header>\r\n\r\n<ng-template #alertsTemplate>\r\n  <layout-system-alert *ngIf=\"alerts && alerts.length\" [alerts]=\"alerts\" (seeAllAlerts)=\"onSeeAllAlerts()\"\r\n    (detailsClicked)=\"onShowDetailsClicked($event)\" (alertDismiss)=\"onAlertDismiss($event)\"></layout-system-alert>\r\n</ng-template>\r\n\r\n<!-- <terms-of-service></terms-of-service> -->" }]
        }], ctorParameters: () => [{ type: i1$3.SystemConfigHeader, decorators: [{
                    type: Optional
                }] }, { type: i1.HttpClient }, { type: i1$3.AuthService }, { type: i1$1.LocationStrategy }, { type: i2.SdsDialogService }, { type: i5.Router }, { type: i1$3.TabCommunicationService }, { type: i5.ActivatedRoute }, { type: i1$3.UserAccessService }, { type: i1$3.AuthUserService }, { type: SignInWorkflowService }, { type: HeaderHelpService }, { type: i0.ChangeDetectorRef }, { type: CmsSystemAlertService }], propDecorators: { spotlightEnabled: [{
                type: Input
            }], header: [{
                type: ViewChild,
                args: [SdsHeaderComponent]
            }], signInButtonStyle: [{
                type: Input
            }], ignoredTermsRedirection: [{
                type: Input
            }], assetsUrl: [{
                type: Input
            }], flagPath: [{
                type: Input
            }] } });

class HeaderModule {
    static forRoot(config) {
        return {
            ngModule: HeaderModule,
            providers: [{ provide: SystemConfigHeader, useValue: config },
                { provide: SharedSystemConfig, useValue: { API_UMBRELLA_URL: config.apiUrl } }],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: HeaderModule, declarations: [HeaderComponent, BadLoginModalComponent, BlockedLoginModalComponent], imports: [CommonModule,
            SdsHeaderModule,
            SystemAlertModule,
            SemDvModule, i1$2.NgxBootstrapIconsModule, SpotlightModule,
            SdsDialogModule,
            TermsOfUseModule], exports: [HeaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderModule, providers: [
            SystemAlertsService,
            UserAccessService,
            SystemBusyService,
            SignInWorkflowService,
            CmsSystemAlertService
        ], imports: [CommonModule,
            SdsHeaderModule,
            SystemAlertModule,
            SemDvModule,
            NgxBootstrapIconsModule.pick({
                arrowLeftSquare,
                arrowRightSquare,
                bell,
                pencilSquare,
                squareFill,
                grid,
                xCircle,
            }),
            SpotlightModule,
            SdsDialogModule,
            TermsOfUseModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: HeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HeaderComponent, BadLoginModalComponent, BlockedLoginModalComponent],
                    imports: [
                        CommonModule,
                        SdsHeaderModule,
                        SystemAlertModule,
                        SemDvModule,
                        NgxBootstrapIconsModule.pick({
                            arrowLeftSquare,
                            arrowRightSquare,
                            bell,
                            pencilSquare,
                            squareFill,
                            grid,
                            xCircle,
                        }),
                        SpotlightModule,
                        SdsDialogModule,
                        TermsOfUseModule
                    ],
                    exports: [HeaderComponent],
                    providers: [
                        SystemAlertsService,
                        UserAccessService,
                        SystemBusyService,
                        SignInWorkflowService,
                        CmsSystemAlertService
                    ],
                }]
        }] });

class FooterComponent {
    // tslint:disable-next-line:max-line-length
    constructor(config, locationStrategy, feedbackService, unleashToggleService) {
        this.config = config;
        this.locationStrategy = locationStrategy;
        this.feedbackService = feedbackService;
        this.unleashToggleService = unleashToggleService;
        this.feedbackModel = new UntypedFormControl('');
        this.isCollapsedContent = true;
        this.showThank = false;
        this.modelFooter = {
            linkSections: [],
            footerLogo: {
                text: 'Logo',
                imageSourcePath: './assets/img/logo-gsa.svg',
                imageAltText: 'GSA Logo',
                href: "https://www.gsa.gov",
                agencyName: "General Services Administration"
            }, disclaimer: `This is a U.S. General Services Administration Federal Government computer system that is <strong>"FOR OFFICIAL USE ONLY."</strong> This system is subject to monitoring. Individuals found performing unauthorized activities are subject to disciplinary action including criminal prosecution.
      <br><br>This system contains Controlled Unclassified Information (CUI). All individuals viewing, reproducing or disposing of this information are required to protect it in accordance with 32 CFR Part 2002 and GSA Order CIO 2103.2 CUI Policy.
     `
        };
        if (config) {
            this.appEnv = config.environment;
        }
        this.setModelFooter();
        this.setLinkWithMode();
    }
    setModelFooter() {
        const ContentSystemName = 'MFE-CONTENT';
        const CMSSystemName = 'CMS';
        this.modelFooter =
            {
                linkSections: [
                    {
                        text: 'Our Website',
                        links: [
                            {
                                text: 'About This Site',
                                route: '/about/this-site',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Our Community',
                                route: 'https://interact.gsa.gov/group/integrated-award-environment-iae-industry-community',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'Release Notes',
                                route: 'https://www.fsd.gov/gsafsd_sp?id=kb_category&kb_category=ccf4380a1ba67410fe314000f54bcb16&kb_id=f66d8e6cdb76d4100d73f81d0f9619c',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'System Alerts',
                                id: 'alerts',
                                systemName: 'SFE',
                                mode: undefined,
                                route: '/alerts'
                            },
                            // {
                            //   text: 'Announcements',
                            //   route: 'https://www.fsd.gov/gsafsd_sp?id=gsafsd_announcements',
                            //   mode: NavigationMode.EXTERNAL
                            // }
                        ]
                    },
                    {
                        text: 'Our Partners',
                        links: [
                            {
                                text: 'Acquisition.gov',
                                route: 'https://Acquisition.gov',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'USASpending.gov',
                                route: 'https://USASpending.gov',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'Grants.gov',
                                route: 'https://Grants.gov',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'More Partners',
                                route: '/about/partners',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            }
                        ]
                    },
                    {
                        text: 'Policies',
                        links: [
                            {
                                text: 'Terms of Use',
                                route: '/about/terms-of-use',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Privacy Policy',
                                route: '/about/terms-of-use#privacy',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Restricted Data Use',
                                route: '/about/terms-of-use#restricted',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Freedom of Information Act',
                                route: 'https://www.gsa.gov/reference/freedom-of-information-act-foia',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'Accessibility',
                                route: '/about/accessibility',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            }
                        ]
                    },
                    {
                        text: 'Customer Service',
                        links: [
                            {
                                text: 'Help',
                                route: '/help',
                                id: 'help',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Check Entity Status',
                                route: '/content/status-tracker',
                                id: 'home',
                                systemName: ContentSystemName, //'MFE-CONTENT',
                                mode: undefined
                            },
                            {
                                text: 'Federal Service Desk',
                                route: 'https://www.fsd.gov/gsafsd_sp/?id=gsa_landing',
                                mode: NavigationMode.EXTERNAL
                            },
                            {
                                text: 'External Resources',
                                route: '/about/external-resources',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            },
                            {
                                text: 'Contact',
                                route: '/about/contact',
                                id: 'home',
                                systemName: CMSSystemName,
                                mode: undefined
                            }
                        ]
                    }
                ],
                footerLogo: {
                    text: 'Logo',
                    imageSourcePath: './assets/img/logo-gsa.svg',
                    imageAltText: 'GSA Logo',
                    href: "https://www.gsa.gov",
                    agencyName: "General Services Administration"
                },
                disclaimer: `This is a U.S. General Services Administration Federal Government computer system that is <strong>"FOR OFFICIAL USE ONLY."</strong> This system is subject to monitoring. Individuals found performing unauthorized activities are subject to disciplinary action including criminal prosecution.
     <br><br>This system contains Controlled Unclassified Information (CUI). All individuals viewing, reproducing or disposing of this information are required to protect it in accordance with 32 CFR Part 2002 and GSA Order CIO 2103.2 CUI Policy.
    `
            };
    }
    ngOnInit() {
        this.setFooterLogo();
    }
    setLinkWithMode() {
        this.modelFooter.linkSections.forEach((section) => {
            if (section.links) {
                section.links.forEach((link) => {
                    /** If link's mode is undefined then set the navigation mode  to internal or external and update the routes */
                    if (link['mode'] === undefined) {
                        link['mode'] = link.systemName.toUpperCase() === this.appEnv.toUpperCase() ? NavigationMode.INTERNAL : NavigationMode.EXTERNAL;
                        if (link['mode'] === NavigationMode.INTERNAL) {
                            link['route'] = link['route'].replace(this.locationStrategy.getBaseHref(), '/');
                        }
                        else {
                            if (link['route'].startsWith('/')) {
                                link['route'] = location.protocol + '//' + location.hostname + link['route'];
                            }
                        }
                    }
                });
            }
        });
    }
    setFooterLogo() {
        if (this.assetsUrl === undefined) {
            this.modelFooter.footerLogo.imageSourcePath = './assets/img/logo-gsa.svg';
        }
        else {
            this.modelFooter.footerLogo.imageSourcePath = this.assetsUrl;
        }
    }
    toggleCollapse() {
        this.isCollapsedContent = !this.isCollapsedContent;
        this.feedbackModel.setValue("");
        this.showThank = false;
        setTimeout(function () {
            const feedTextArea = document.getElementById("feedbackInput");
            if (feedTextArea) {
                feedTextArea.focus();
                feedTextArea.scrollIntoView({ block: "center", inline: "center" });
            }
        });
    }
    moreFeedBack() {
        this.showThank = false;
        this.feedbackModel.setValue("");
        setTimeout(function () {
            const feedTextArea = document.getElementById("feedbackInput");
            if (feedTextArea) {
                feedTextArea.focus();
                feedTextArea.scrollIntoView({ block: "center", inline: "center" });
            }
        });
    }
    submitFeedback() {
        const url = window.location.pathname + window.location.search;
        const res = {
            questionId: 5,
            userId: '',
            feedback_response: {
                type: 'textarea',
                selected: [this.feedbackModel.value],
            },
        };
        const request = {
            feedbackList: [res],
            userId: '',
            feedbackPath: url
        };
        if (!this.hdnField) {
            this.feedbackService.createFeedback(request).subscribe({
                next: this.feedbackSuccess.bind(this),
                error: this.feedbackError.bind(this)
            });
        }
        else {
            console.error('Invalid feedback');
        }
    }
    feedbackError() {
        console.error("submitting feedback failed");
    }
    feedbackSuccess() {
        this.showThank = true;
        this.feedbackModel.setValue("");
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FooterComponent, deps: [{ token: i1$3.SystemConfigFooter, optional: true }, { token: i1$1.LocationStrategy }, { token: i1$3.FeedbackService }, { token: i1$3.UnleashToggleService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: FooterComponent, selector: "layout-footer", inputs: { assetsUrl: "assetsUrl" }, ngImport: i0, template: "<sds-footer [model]=\"modelFooter\" [feedbackTemplate]=\"feedbackThankyouTemplate\">\r\n</sds-footer>\r\n<ng-template #feedbackThankyouTemplate>\r\n  <div class=\"sds-feedback\">\r\n    <button\r\n      type=\"button\"\r\n      id=\"feedback-toggle-button\"\r\n      class=\"sds-feedback__button simple-toggle\"\r\n      [attr.aria-expanded]=\"!isCollapsedContent\"\r\n      aria-controls=\"collapseID\"\r\n      (click)=\"toggleCollapse()\"\r\n    >\r\n      <usa-icon\r\n        [icon]=\"'arrow-up-circle-fill'\"\r\n        [sdsCollapse]=\"isCollapsedContent\"\r\n        [size]=\"'2x'\"\r\n        class=\"text-primary margin-auto\"\r\n      ></usa-icon>\r\n\r\n      <usa-icon\r\n        [icon]=\"'arrow-down-circle-fill'\"\r\n        [size]=\"'2x'\"\r\n        [sdsCollapse]=\"!isCollapsedContent\"\r\n        class=\"text-primary margin-auto\"\r\n      ></usa-icon>\r\n\r\n      <span class=\"sds-feedback__title\">Feedback</span>\r\n    </button>\r\n    <div\r\n      id=\"collapseID\"\r\n      [sdsCollapse]=\"isCollapsedContent\"\r\n      class=\"sds-feedback__response\"\r\n    >\r\n      <div\r\n        class=\"tablet:width-tablet-lg padding-4 margin-auto\"\r\n        *ngIf=\"!showThank\"\r\n      >\r\n        <span class=\"sds-feedback__response-title\"\r\n          >We welcome you to provide feedback on this site.\r\n        </span>\r\n        <div class=\"sds-feedback__response text-base-dark margin-top-1\">\r\n          If you have a technical issue or need a question answered, please go\r\n          to the\r\n          <a class=\"usa-link text-bold\" href=\"http://fsd.gov/\" target=\"_blank\"\r\n            >Federal Service Desk.</a\r\n          >\r\n        </div>\r\n        <textarea\r\n          [formControl]=\"feedbackModel\"\r\n          class=\"sds-feedback__input\"\r\n          id=\"feedbackInput\"\r\n          aria-label=\"Feedback input form\"\r\n          type=\"text\"\r\n          rows=\"8\"\r\n        ></textarea>\r\n        <input id=\"hiddenFeedback\" type=\"hidden\" [(ngModel)]=\"hdnField\" />\r\n        <p class=\"text-left\">\r\n          <button\r\n            class=\"usa-button usa-button bg-primary-lighter\"\r\n            id=\"feedbackSubmit\"\r\n            aria-label=\"Feedback submit\"\r\n            [disabled]=\"!feedbackModel.value?.trim()\"\r\n            (click)=\"submitFeedback()\"\r\n          >\r\n            Submit\r\n          </button>\r\n        </p>\r\n      </div>\r\n      <div *ngIf=\"showThank\">\r\n        <div class=\"thank-you-text\">\r\n          <p class=\"sds-feedback__response-title\">\r\n            Thank You For Your Feedback!\r\n          </p>\r\n        </div>\r\n        <br />\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          Thank you for providing feedback on SAM.gov. Although we are not able\r\n          to respond\r\n        </div>\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          individually to each user, we value your input. We review all\r\n          submissions to help\r\n        </div>\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          improve the system and the user experience.\r\n        </div>\r\n        <div class=\"thank-you-text text-center text-base-dark margin-top-1\">\r\n          If you are in need of individual assistance, please contact the\r\n          <a class=\"usa-link text-bold\" href=\"http://fsd.gov/\" target=\"_blank\"\r\n            >Federal Service Desk.</a\r\n          >\r\n        </div>\r\n        <div class=\"text-center thank-you-text margin-top-1\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"usa-button text-center usa-button--unstyled\"\r\n            (click)=\"moreFeedBack()\"\r\n          >\r\n            Provide More Feedback\r\n          </button>\r\n        </div>\r\n        <div class=\"text-center thank-you-text margin-top-1\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"usa-button text-center\"\r\n            (click)=\"toggleCollapse()\"\r\n          >\r\n            Close\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".usa-footer__logo-img{width:100%!important}.thank-you-text{text-align:center;padding:3px 0!important}.sds-feedback__response{padding:0!important}.margin-top-1{margin-bottom:.5rem!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i9.SdsFooterComponent, selector: "sds-footer", inputs: ["model", "feedbackTemplate"], outputs: ["linkEvent", "feedbackSubmit"] }, { kind: "directive", type: i2.CollapseDirective, selector: "[sdsCollapse]", inputs: ["sdsCollapse"], exportAs: ["sdsCollapse"] }, { kind: "component", type: i2$1.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'layout-footer', template: "<sds-footer [model]=\"modelFooter\" [feedbackTemplate]=\"feedbackThankyouTemplate\">\r\n</sds-footer>\r\n<ng-template #feedbackThankyouTemplate>\r\n  <div class=\"sds-feedback\">\r\n    <button\r\n      type=\"button\"\r\n      id=\"feedback-toggle-button\"\r\n      class=\"sds-feedback__button simple-toggle\"\r\n      [attr.aria-expanded]=\"!isCollapsedContent\"\r\n      aria-controls=\"collapseID\"\r\n      (click)=\"toggleCollapse()\"\r\n    >\r\n      <usa-icon\r\n        [icon]=\"'arrow-up-circle-fill'\"\r\n        [sdsCollapse]=\"isCollapsedContent\"\r\n        [size]=\"'2x'\"\r\n        class=\"text-primary margin-auto\"\r\n      ></usa-icon>\r\n\r\n      <usa-icon\r\n        [icon]=\"'arrow-down-circle-fill'\"\r\n        [size]=\"'2x'\"\r\n        [sdsCollapse]=\"!isCollapsedContent\"\r\n        class=\"text-primary margin-auto\"\r\n      ></usa-icon>\r\n\r\n      <span class=\"sds-feedback__title\">Feedback</span>\r\n    </button>\r\n    <div\r\n      id=\"collapseID\"\r\n      [sdsCollapse]=\"isCollapsedContent\"\r\n      class=\"sds-feedback__response\"\r\n    >\r\n      <div\r\n        class=\"tablet:width-tablet-lg padding-4 margin-auto\"\r\n        *ngIf=\"!showThank\"\r\n      >\r\n        <span class=\"sds-feedback__response-title\"\r\n          >We welcome you to provide feedback on this site.\r\n        </span>\r\n        <div class=\"sds-feedback__response text-base-dark margin-top-1\">\r\n          If you have a technical issue or need a question answered, please go\r\n          to the\r\n          <a class=\"usa-link text-bold\" href=\"http://fsd.gov/\" target=\"_blank\"\r\n            >Federal Service Desk.</a\r\n          >\r\n        </div>\r\n        <textarea\r\n          [formControl]=\"feedbackModel\"\r\n          class=\"sds-feedback__input\"\r\n          id=\"feedbackInput\"\r\n          aria-label=\"Feedback input form\"\r\n          type=\"text\"\r\n          rows=\"8\"\r\n        ></textarea>\r\n        <input id=\"hiddenFeedback\" type=\"hidden\" [(ngModel)]=\"hdnField\" />\r\n        <p class=\"text-left\">\r\n          <button\r\n            class=\"usa-button usa-button bg-primary-lighter\"\r\n            id=\"feedbackSubmit\"\r\n            aria-label=\"Feedback submit\"\r\n            [disabled]=\"!feedbackModel.value?.trim()\"\r\n            (click)=\"submitFeedback()\"\r\n          >\r\n            Submit\r\n          </button>\r\n        </p>\r\n      </div>\r\n      <div *ngIf=\"showThank\">\r\n        <div class=\"thank-you-text\">\r\n          <p class=\"sds-feedback__response-title\">\r\n            Thank You For Your Feedback!\r\n          </p>\r\n        </div>\r\n        <br />\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          Thank you for providing feedback on SAM.gov. Although we are not able\r\n          to respond\r\n        </div>\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          individually to each user, we value your input. We review all\r\n          submissions to help\r\n        </div>\r\n        <div class=\"thank-you-text text-base-dark\">\r\n          improve the system and the user experience.\r\n        </div>\r\n        <div class=\"thank-you-text text-center text-base-dark margin-top-1\">\r\n          If you are in need of individual assistance, please contact the\r\n          <a class=\"usa-link text-bold\" href=\"http://fsd.gov/\" target=\"_blank\"\r\n            >Federal Service Desk.</a\r\n          >\r\n        </div>\r\n        <div class=\"text-center thank-you-text margin-top-1\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"usa-button text-center usa-button--unstyled\"\r\n            (click)=\"moreFeedBack()\"\r\n          >\r\n            Provide More Feedback\r\n          </button>\r\n        </div>\r\n        <div class=\"text-center thank-you-text margin-top-1\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"usa-button text-center\"\r\n            (click)=\"toggleCollapse()\"\r\n          >\r\n            Close\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".usa-footer__logo-img{width:100%!important}.thank-you-text{text-align:center;padding:3px 0!important}.sds-feedback__response{padding:0!important}.margin-top-1{margin-bottom:.5rem!important}\n"] }]
        }], ctorParameters: () => [{ type: i1$3.SystemConfigFooter, decorators: [{
                    type: Optional
                }] }, { type: i1$1.LocationStrategy }, { type: i1$3.FeedbackService }, { type: i1$3.UnleashToggleService }], propDecorators: { assetsUrl: [{
                type: Input
            }] } });

class FooterModule {
    static forRoot(config) {
        return {
            ngModule: FooterModule,
            providers: [
                { provide: SystemConfigFooter, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FooterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: FooterModule, declarations: [FooterComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            SdsFooterModule,
            SdsCollapseModule,
            IconModule, i1$2.NgxBootstrapIconsModule], exports: [FooterComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FooterModule, providers: [
            FeedbackService
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            SdsFooterModule,
            SdsCollapseModule,
            IconModule,
            NgxBootstrapIconsModule.pick({ arrowDownCircleFill, arrowUpCircleFill })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: FooterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FooterComponent],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        SdsFooterModule,
                        SdsCollapseModule,
                        IconModule,
                        NgxBootstrapIconsModule.pick({ arrowDownCircleFill, arrowUpCircleFill }),
                    ],
                    providers: [
                        FeedbackService
                    ],
                    exports: [FooterComponent]
                }]
        }] });

class SystemConfig {
}

class GenericThreadService {
    constructor(http, authService, environment) {
        this.http = http;
        this.authService = authService;
        this.environment = environment;
    }
    createThread(thread) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/thread`;
        return this.http.post(url, thread, this._options());
    }
    createComment(comment, threadId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/comment/${threadId}`;
        return this.http.post(url, comment, this._options());
    }
    editComment(comment, commentId) {
        this.loggedIn();
        let clone = JSON.parse(JSON.stringify(comment));
        clone.createdDate = undefined;
        clone.createdBy = undefined;
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/comment/${commentId}`;
        return this.http.put(url, clone, this._options());
    }
    deleteComment(comment) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/comment/${comment.id}`;
        let op = this._options();
        let clone = JSON.parse(JSON.stringify(comment));
        clone.createdDate = undefined;
        clone.createdBy = undefined;
        op['body'] = clone;
        return this.http.delete(url, op);
    }
    getComments(threadId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/comments/${threadId}`;
        let op = this._options();
        return this.http.get(url, op);
    }
    getCommentCount(threadId) {
        this.loggedIn();
        const url = `${this.environment.API_UMBRELLA_URL}/comment/v1/comments/count/${threadId}`;
        let op = this._options();
        return this.http.get(url, op);
    }
    _options() {
        const params = {};
        return {
            headers: {
                'X-Auth-Token': this.authService.authToken()
            },
            params: params
        };
    }
    loggedIn() {
        if (!this.authService.isLoggedIn()) {
            throw new Error('Must be authenticated');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadService, deps: [{ token: i1.HttpClient }, { token: i1$3.AuthService }, { token: SystemConfig }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i1$3.AuthService }, { type: SystemConfig, decorators: [{
                    type: Inject,
                    args: [SystemConfig]
                }] }] });
class ThreadEntity {
    constructor(id, sourceName, sourceId) {
        this.id = id;
        this.sourceName = sourceName;
        this.sourceId = sourceId;
    }
}
class CommentEntity {
    constructor(id, threadId, comment, firstName, lastName, role, showUser, createdDate) {
        this.id = id;
        this.threadId = threadId;
        this.comment = comment;
        this.firstName = firstName;
        this.lastName = lastName;
        this.role = role;
        this.showUser = showUser;
        this.createdDate = createdDate;
    }
}

class WindowSizeComponent {
    constructor() {
        this.WindowSize = WindowSize;
        this.windowSizeChange = new EventEmitter();
        this.windowSize = WindowSize.MIN;
    }
    displayResizeIcon(windowSize) {
        if (windowSize === WindowSize.MAX && window.innerWidth < 960) {
            return false;
        }
        else if (windowSize === WindowSize.MID && window.innerHeight < 640) {
            return false;
        }
        else if (windowSize === WindowSize.MIN && window.innerHeight < 320) {
            return false;
        }
        return true;
    }
    selectWindowSize(windowSize) {
        this.windowSize = windowSize;
        this.windowSizeChange.emit(windowSize);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: WindowSizeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: WindowSizeComponent, selector: "window-size", outputs: { windowSizeChange: "windowSizeChange" }, host: { listeners: { "window:resize": "displayResizeIcon($event)" } }, ngImport: i0, template: "<div class=\"grid-container padding-top-1 padding-right-1 padding-bottom-4\">\r\n    <div class=\"grid-row\">\r\n        <div class=\"pin-right\">\r\n            <span class=\"font-sans-2xs grid-col-auto\">\r\n                Choose Window Size\r\n            </span>\r\n            <button *ngIf=\"displayResizeIcon(0)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(0)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MAX?'wide_window_blue':'wide_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Wide window</div>\r\n                </usa-icon>\r\n            </button>\r\n\r\n            <button *ngIf=\"displayResizeIcon(1)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(1)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MID?'middle_window_blue':'middle_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Middle window</div>\r\n                </usa-icon>\r\n            </button>\r\n\r\n            <button *ngIf=\"displayResizeIcon(2)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(2)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MIN?'narrow_window_blue':'narrow_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Narrow window</div>\r\n                </usa-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: WindowSizeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'window-size', template: "<div class=\"grid-container padding-top-1 padding-right-1 padding-bottom-4\">\r\n    <div class=\"grid-row\">\r\n        <div class=\"pin-right\">\r\n            <span class=\"font-sans-2xs grid-col-auto\">\r\n                Choose Window Size\r\n            </span>\r\n            <button *ngIf=\"displayResizeIcon(0)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(0)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MAX?'wide_window_blue':'wide_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Wide window</div>\r\n                </usa-icon>\r\n            </button>\r\n\r\n            <button *ngIf=\"displayResizeIcon(1)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(1)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MID?'middle_window_blue':'middle_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Middle window</div>\r\n                </usa-icon>\r\n            </button>\r\n\r\n            <button *ngIf=\"displayResizeIcon(2)\" class=\"usa-button usa-button--unstyled  padding-left-1 grid-col-auto\" (click)=\"selectWindowSize(2)\">\r\n                <usa-icon class=\"text-info\"\r\n                    [icon]=\"windowSize===WindowSize.MIN?'narrow_window_blue':'narrow_window_grey'\" [size]=\"'2x'\">\r\n                    <div class=\"usa-sr-only\">Narrow window</div>\r\n                </usa-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { windowSizeChange: [{
                type: Output
            }], displayResizeIcon: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });
var WindowSize;
(function (WindowSize) {
    WindowSize[WindowSize["MAX"] = 0] = "MAX";
    WindowSize[WindowSize["MID"] = 1] = "MID";
    WindowSize[WindowSize["MIN"] = 2] = "MIN";
})(WindowSize || (WindowSize = {}));

class CommentComponent {
    ngOnInit() {
    }
    constructor(dialog) {
        this.dialog = dialog;
        this.CommentMode = CommentMode;
        this.characterCountShowMore = 200;
        this.showMore = false;
        this.deleteCommentEvent = new EventEmitter();
        this.editCommentEvent = new EventEmitter();
        this.showMoreShowLess = new EventEmitter();
        this.commmentMode = CommentMode.READ;
        this.model = { commentField: '' };
    }
    showMoreClick() {
        this.showMoreShowLess.emit({ showMore: true, comment: this.comment });
    }
    showLessClick() {
        this.showMoreShowLess.emit({ showMore: false, comment: null });
    }
    getTextAreaCol() {
        let colCount = 0;
        switch (this.windowSize) {
            case WindowSize.MAX:
                colCount = 118;
                break;
            case WindowSize.MID:
                colCount = 75;
                break;
            case WindowSize.MIN:
                colCount = 30;
                break;
            default:
                break;
        }
        return colCount;
    }
    getDateFormat(date2) {
        let date = new Date(date2);
        let hours = date.getHours();
        if (hours === 0) {
            hours = 12;
        }
        else if (hours > 12) {
            hours = hours - 12;
        }
        return this.getWordMonth(date.getMonth()) + ' ' + date.getDate() + ', ' + date.getFullYear() + ' at ' + hours + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ((date.getHours() >= 12 && date.getHours() <= 23) ? 'PM' : 'AM');
    }
    getWordMonth(num) {
        let monthTxt = '';
        //off by one
        switch (num + 1) {
            case 1:
                monthTxt = 'January';
                break;
            case 2:
                monthTxt = 'February';
                break;
            case 3:
                monthTxt = 'March';
                break;
            case 4:
                monthTxt = 'April';
                break;
            case 5:
                monthTxt = 'May';
                break;
            case 6:
                monthTxt = 'June';
                break;
            case 7:
                monthTxt = 'July';
                break;
            case 8:
                monthTxt = 'August';
                break;
            case 9:
                monthTxt = 'September';
                break;
            case 10:
                monthTxt = 'October';
                break;
            case 11:
                monthTxt = 'November';
                break;
            case 12:
                monthTxt = 'December';
                break;
            default:
                break;
        }
        return monthTxt;
    }
    editComment() {
        this.model.commentField = this.comment.comment;
        this.commmentMode = CommentMode.UPDATE;
    }
    saveEditComment() {
        this.comment.comment = this.model.commentField;
        this.editCommentEvent.emit(this.comment);
        this.commmentMode = CommentMode.READ;
    }
    deleteComment() {
        this.openDeleteModal();
    }
    cancelEditComment() {
        this.commmentMode = CommentMode.READ;
    }
    openDeleteModal() {
        const deleteDialog = this.dialog.open(AlertComponent, {
            alert: 'warning',
            width: 'Small',
            data: {},
        });
        deleteDialog.afterClosed().subscribe(result => this.deleteModalClosed(result));
    }
    deleteModalClosed(result) {
        if (result.deleteStatus) {
            this.deleteCommentEvent.emit(this.comment);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CommentComponent, deps: [{ token: i2.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: CommentComponent, selector: "comment", inputs: { showMore: "showMore", comment: "comment", disabledEditComments: "disabledEditComments", disabledDeleteComments: "disabledDeleteComments", maxCommentLength: "maxCommentLength", windowSize: "windowSize" }, outputs: { deleteCommentEvent: "deleteCommentEvent", editCommentEvent: "editCommentEvent", showMoreShowLess: "showMoreShowLess" }, ngImport: i0, template: "<div class=\"position-relative padding-x padding-y  width-full \">\r\n  <div class=\"margin-1 radius-md bg-white shadow-3 border border-base-light\">\r\n    <div class=\"height-full\">\r\n      <div class=\" padding-left-1 padding-right-1 padding-top-1 \">\r\n        <!--Abbr, Name, Role-->\r\n        <div class=\"padding-bottom-1\">\r\n          <div class=\"grid-container padding-0\">\r\n            <div class=\"grid-row grid-gap-1 flex-align-center\">\r\n              <div class=\"grid-col flex-auto flex-align-center\">\r\n                <div\r\n                  class=\"circle-3 display-flex flex-align-center flex-justify-center text-center outline-1px outline-accent-cool-dark bg-accent-cool-light font-sans-3xs\">\r\n                  <div class=\"display-flex flex-align-center \">\r\n                    {{comment.firstName.substring(0,1)+comment.lastName.substring(0,1)}}\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"grid-col flex-auto flex-align-center font-sans-xs \">\r\n                <span class=\"text-semibold \"> {{comment.firstName}} {{comment.lastName }}</span>\r\n              </div>\r\n              <div class=\"grid-col flex-auto font-sans-2xs\">\r\n                <span class=\"text-italic \"> {{comment.role}}</span>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!--Date-->\r\n        <div class=\" padding-right-1 font-sans-3xs\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          {{ getDateFormat(comment.createdDate) }}\r\n        </div>\r\n        <!--Comment-->\r\n        <div class=\" padding-right-1 padding-bottom-1 font-sans-xs\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          <div *ngIf=\"comment.comment.length<=characterCountShowMore||showMore\">\r\n            {{comment.comment}}\r\n          </div>\r\n\r\n          <div class=\"padding-right-1 padding-bottom-1 font-sans-xs\"\r\n            *ngIf=\"comment.comment.length>characterCountShowMore&&!showMore\">\r\n            {{comment.comment.substring(0,characterCountShowMore)}}\r\n          </div>\r\n        </div>\r\n\r\n        <!--Inline Edit-->\r\n        <div class=\"padding-left-1 padding-right-1\"\r\n          style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n          *ngIf=\"commmentMode===CommentMode.UPDATE\">\r\n          <textarea title=\"Edit Comment\" placeholder=\"Write a comment\u2026\" style=\"resize: none;\"\r\n            [(ngModel)]=\"model.commentField\" id=\"txtArea\" [maxlength]=\"maxCommentLength\" [rows]=\"showMore?25:5\"\r\n            [attr.cols]=\" getTextAreaCol()\"></textarea>\r\n        </div>\r\n        <!--  More Less, Edit, Delete buttons-->\r\n        <div class=\"grid-container padding-0\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          <div class=\"grid-row flex-align-center\">\r\n            <div class=\"grid-col display-flex flex-row\">\r\n              <div class=\"flex-1 padding-1px flex-align-self-center display-flex flex-align-center flex-justify-center\">\r\n                <button class=\" usa-button usa-button--unstyled sds-button--small\"\r\n                  *ngIf=\"comment.comment.length>characterCountShowMore&& !showMore\" (click)=\"showMoreClick()\">\r\n                  More\r\n                  <usa-icon [icon]=\"'chevron-down'\" [size]=\"'x'\">\r\n                  </usa-icon>\r\n                </button>\r\n                <button class=\"usa-button usa-button--unstyled sds-button--small\" *ngIf=\"showMore\"\r\n                  (click)=\"showLessClick()\">Less\r\n                  <usa-icon [icon]=\"'chevron-up'\" [size]=\"'x'\">\r\n                  </usa-icon>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col flex-auto\">\r\n              <div *ngIf=\"comment.createdByUser\" class=\"pos-right\">\r\n                <button *ngIf=\"!disabledEditComments\" (click)=\"editComment()\"\r\n                  class=\"padding-right-1 usa-button usa-button--unstyled font-sans-2xs\">Edit</button>\r\n                <button *ngIf=\"!disabledDeleteComments\" (click)=\"deleteComment()\"\r\n                  class=\"usa-button usa-button--unstyled font-sans-2xs\">\r\n                  Delete</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Save and Cancel-->\r\n        <div class=\"grid-container padding-0 padding-bottom-1\" *ngIf=\"commmentMode===CommentMode.UPDATE\">\r\n          <div class=\"grid-row flex-column flex-align-end\">\r\n            <div class=\"grid-col flex-fill\">\r\n              <div class=\"\">\r\n                <button (click)=\"cancelEditComment()\"\r\n                  class=\" pos-right usa-button sds-button--small usa-button--base bg-base-lighter font-sans-2xs\">Cancel</button>\r\n                <button (click)=\"saveEditComment()\"\r\n                  class=\" pos-right usa-button sds-button--small usa-button--accent-cool font-sans-2xs\">\r\n                  Save</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: CommentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'comment', template: "<div class=\"position-relative padding-x padding-y  width-full \">\r\n  <div class=\"margin-1 radius-md bg-white shadow-3 border border-base-light\">\r\n    <div class=\"height-full\">\r\n      <div class=\" padding-left-1 padding-right-1 padding-top-1 \">\r\n        <!--Abbr, Name, Role-->\r\n        <div class=\"padding-bottom-1\">\r\n          <div class=\"grid-container padding-0\">\r\n            <div class=\"grid-row grid-gap-1 flex-align-center\">\r\n              <div class=\"grid-col flex-auto flex-align-center\">\r\n                <div\r\n                  class=\"circle-3 display-flex flex-align-center flex-justify-center text-center outline-1px outline-accent-cool-dark bg-accent-cool-light font-sans-3xs\">\r\n                  <div class=\"display-flex flex-align-center \">\r\n                    {{comment.firstName.substring(0,1)+comment.lastName.substring(0,1)}}\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"grid-col flex-auto flex-align-center font-sans-xs \">\r\n                <span class=\"text-semibold \"> {{comment.firstName}} {{comment.lastName }}</span>\r\n              </div>\r\n              <div class=\"grid-col flex-auto font-sans-2xs\">\r\n                <span class=\"text-italic \"> {{comment.role}}</span>\r\n              </div>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!--Date-->\r\n        <div class=\" padding-right-1 font-sans-3xs\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          {{ getDateFormat(comment.createdDate) }}\r\n        </div>\r\n        <!--Comment-->\r\n        <div class=\" padding-right-1 padding-bottom-1 font-sans-xs\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          <div *ngIf=\"comment.comment.length<=characterCountShowMore||showMore\">\r\n            {{comment.comment}}\r\n          </div>\r\n\r\n          <div class=\"padding-right-1 padding-bottom-1 font-sans-xs\"\r\n            *ngIf=\"comment.comment.length>characterCountShowMore&&!showMore\">\r\n            {{comment.comment.substring(0,characterCountShowMore)}}\r\n          </div>\r\n        </div>\r\n\r\n        <!--Inline Edit-->\r\n        <div class=\"padding-left-1 padding-right-1\"\r\n          style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n          *ngIf=\"commmentMode===CommentMode.UPDATE\">\r\n          <textarea title=\"Edit Comment\" placeholder=\"Write a comment\u2026\" style=\"resize: none;\"\r\n            [(ngModel)]=\"model.commentField\" id=\"txtArea\" [maxlength]=\"maxCommentLength\" [rows]=\"showMore?25:5\"\r\n            [attr.cols]=\" getTextAreaCol()\"></textarea>\r\n        </div>\r\n        <!--  More Less, Edit, Delete buttons-->\r\n        <div class=\"grid-container padding-0\" *ngIf=\"commmentMode===CommentMode.READ\">\r\n          <div class=\"grid-row flex-align-center\">\r\n            <div class=\"grid-col display-flex flex-row\">\r\n              <div class=\"flex-1 padding-1px flex-align-self-center display-flex flex-align-center flex-justify-center\">\r\n                <button class=\" usa-button usa-button--unstyled sds-button--small\"\r\n                  *ngIf=\"comment.comment.length>characterCountShowMore&& !showMore\" (click)=\"showMoreClick()\">\r\n                  More\r\n                  <usa-icon [icon]=\"'chevron-down'\" [size]=\"'x'\">\r\n                  </usa-icon>\r\n                </button>\r\n                <button class=\"usa-button usa-button--unstyled sds-button--small\" *ngIf=\"showMore\"\r\n                  (click)=\"showLessClick()\">Less\r\n                  <usa-icon [icon]=\"'chevron-up'\" [size]=\"'x'\">\r\n                  </usa-icon>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <div class=\"grid-col flex-auto\">\r\n              <div *ngIf=\"comment.createdByUser\" class=\"pos-right\">\r\n                <button *ngIf=\"!disabledEditComments\" (click)=\"editComment()\"\r\n                  class=\"padding-right-1 usa-button usa-button--unstyled font-sans-2xs\">Edit</button>\r\n                <button *ngIf=\"!disabledDeleteComments\" (click)=\"deleteComment()\"\r\n                  class=\"usa-button usa-button--unstyled font-sans-2xs\">\r\n                  Delete</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Save and Cancel-->\r\n        <div class=\"grid-container padding-0 padding-bottom-1\" *ngIf=\"commmentMode===CommentMode.UPDATE\">\r\n          <div class=\"grid-row flex-column flex-align-end\">\r\n            <div class=\"grid-col flex-fill\">\r\n              <div class=\"\">\r\n                <button (click)=\"cancelEditComment()\"\r\n                  class=\" pos-right usa-button sds-button--small usa-button--base bg-base-lighter font-sans-2xs\">Cancel</button>\r\n                <button (click)=\"saveEditComment()\"\r\n                  class=\" pos-right usa-button sds-button--small usa-button--accent-cool font-sans-2xs\">\r\n                  Save</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>" }]
        }], ctorParameters: () => [{ type: i2.SdsDialogService }], propDecorators: { showMore: [{
                type: Input
            }], comment: [{
                type: Input
            }], disabledEditComments: [{
                type: Input
            }], disabledDeleteComments: [{
                type: Input
            }], maxCommentLength: [{
                type: Input
            }], windowSize: [{
                type: Input
            }], deleteCommentEvent: [{
                type: Output
            }], editCommentEvent: [{
                type: Output
            }], showMoreShowLess: [{
                type: Output
            }] } });
/**
 * ALERTS
 * ================================================
 */
// Error
class AlertComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    close(status) {
        this.dialogRef.close({ 'deleteStatus': status, });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AlertComponent, deps: [{ token: SDS_DIALOG_DATA }, { token: i2.SdsDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: AlertComponent, selector: "dialog-alert", ngImport: i0, template: `

  <div sds-dialog-title>Are you sure you want to delete this comment?</div>
<div class="padding-bottom-2"> </div>
<div sds-dialog-actions>
  <div class="grid-container">
  <div class="grid-row">
    <div class="grid-col">
      <button (click)="close(false)" class="usa-button usa-button--base bg-base-lighter">Back</button>
    </div>
    <div class="grid-col">
      <button (click)="close(true)" cdkFocusInitial class="usa-button">Delete</button>
    </div>
  </div>
</div>
</div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dialog-alert',
                    template: `

  <div sds-dialog-title>Are you sure you want to delete this comment?</div>
<div class="padding-bottom-2"> </div>
<div sds-dialog-actions>
  <div class="grid-container">
  <div class="grid-row">
    <div class="grid-col">
      <button (click)="close(false)" class="usa-button usa-button--base bg-base-lighter">Back</button>
    </div>
    <div class="grid-col">
      <button (click)="close(true)" cdkFocusInitial class="usa-button">Delete</button>
    </div>
  </div>
</div>
</div>
  `,
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SDS_DIALOG_DATA]
                }] }, { type: i2.SdsDialogRef }] });
var CommentMode;
(function (CommentMode) {
    CommentMode[CommentMode["UPDATE"] = 0] = "UPDATE";
    CommentMode[CommentMode["READ"] = 1] = "READ";
})(CommentMode || (CommentMode = {}));
class ShowMoreLessData {
}

class TemplateViewComponent {
    constructor() {
        this.templateSelected = new EventEmitter();
        this.isEditMode = false;
        this.settings = new SDSAutocompletelConfiguration();
        this.model = new SDSSelectedItemModel();
        this.isEditMode = false;
        this.setup();
    }
    changes(value) {
        console.log(value);
        this.previewText = value[0]["templateText"];
        this.templateTitle = value[0]['name'];
    }
    ngOnInit() {
    }
    getTextAreaCol() {
        let colCount = 0;
        switch (this.windowSize) {
            case WindowSize.MAX:
                colCount = 118;
                break;
            case WindowSize.MID:
                colCount = 75;
                break;
            case WindowSize.MIN:
                colCount = 35;
                break;
            default:
                break;
        }
        return colCount;
    }
    editText(value) {
        this.textLengthRemain = this.maxCommentLength - value.length;
        console.log(this.maxCommentLength);
        console.log(this.previewText.length);
    }
    send() {
        this.templateSelected.emit(this.previewText);
        this.isEditMode = false;
    }
    setup() {
        this.settings.id = 'templateComment';
        this.settings.primaryKeyField = 'id';
        this.settings.primaryTextField = 'name';
        this.settings.secondaryTextField = 'subtext';
        this.settings.labelText = 'Template Selection';
        this.settings.selectionMode = SelectionMode.SINGLE;
        this.settings.autocompletePlaceHolderText = 'eg: template name';
    }
    cancel() {
        this.isEditMode = false;
        this.templateSelected.emit("");
    }
    insert() {
        console.log(this.maxCommentLength);
        console.log(this.previewText.length);
        this.textLengthRemain = this.maxCommentLength - this.previewText.length;
        this.isEditMode = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TemplateViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TemplateViewComponent, selector: "template-view", inputs: { threadId: "threadId", source: "source", sourceId: "sourceId", role: "role", showUser: "showUser", service: "service", templateService: "templateService", maxCommentLength: "maxCommentLength", windowSize: "windowSize" }, outputs: { templateSelected: "templateSelected" }, ngImport: i0, template: "<div>\r\n    <div *ngIf=\"!isEditMode\" class=\"margin-1\">\r\n        <div>Select Template</div>\r\n        <sds-autocomplete ariaLabelText=\"Select Template\" [service]=\"templateService\" (ngModelChange)=\"changes($event)\"\r\n            [(ngModel)]=\"model\" [configuration]=\"settings\"></sds-autocomplete>\r\n    </div>\r\n    <div *ngIf=\"!isEditMode\">\r\n        <div class=\"bg-gray-10 margin-1\">\r\n            <div class=\"bg-gray-10 margin-2\">\r\n                <div class=\"grid-row\">\r\n                    <div class=\"tablet:grid-col display-flex flex-align-center flex-justify-center\">\r\n                        <div class=\"text-bold font-sans-2xl flex-align-center text-gray-50\">\r\n                            Preview\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"grid-row margin-bottom-1 margin-top-1\">\r\n                    <div class=\"tablet:grid-col\">\r\n                        {{templateTitle}}\r\n                    </div>\r\n                </div>\r\n                <div class=\"grid-row\">\r\n                    <div class=\"tablet:grid-col\">\r\n                        {{previewText}}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isEditMode\">\r\n        <textarea class=\"margin-left-2\" title=\"Comment\" placeholder=\"Write a comment\u2026\"\r\n            style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n            [(ngModel)]=\"previewText\" (ngModelChange)=\"editText($event)\" id=\"txtArea\" [maxlength]=\"maxCommentLength\"\r\n            [attr.rows]=\"25\" [attr.cols]=\"getTextAreaCol()\"></textarea>\r\n\r\n\r\n        <div class=\"grid-container margin-bottom-1\">\r\n            <div class=\"grid-row flex-column flex-align-end\">\r\n                <div class=\"grid-col flex-fill\">\r\n                    <div *ngIf=\"textLengthRemain>0\" class=\"pos-right\">\r\n                        {{textLengthRemain}} characters remaining\r\n                    </div>\r\n                    <div *ngIf=\"textLengthRemain===0\" class=\"pos-right\">\r\n                        Text truncated, {{textLengthRemain}} characters remaining\r\n                    </div>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n    <div class=\"grid-container padding-0 padding-bottom-1\">\r\n        <div class=\"grid-row flex-column flex-align-end\">\r\n            <div class=\"grid-col flex-fill\">\r\n                <button class=\" pos-right usa-button usa-button--accent-cool\" (click)=\"cancel()\">Cancel</button>\r\n                <button *ngIf=\"!isEditMode\" class=\"pos-right usa-button usa-button--accent-cool\"\r\n                    [disabled]=\"!previewText\" (click)=\"insert()\">Insert</button>\r\n                <button *ngIf=\"isEditMode\" class=\"pos-right usa-button usa-button--accent-cool\"\r\n                    [disabled]=\"!previewText\" (click)=\"send()\">Send</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2.SDSAutocompleteComponent, selector: "sds-autocomplete", inputs: ["suggestionTemplate", "selectedItemTemplate", "configuration", "essentialModelFields", "service"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TemplateViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'template-view', template: "<div>\r\n    <div *ngIf=\"!isEditMode\" class=\"margin-1\">\r\n        <div>Select Template</div>\r\n        <sds-autocomplete ariaLabelText=\"Select Template\" [service]=\"templateService\" (ngModelChange)=\"changes($event)\"\r\n            [(ngModel)]=\"model\" [configuration]=\"settings\"></sds-autocomplete>\r\n    </div>\r\n    <div *ngIf=\"!isEditMode\">\r\n        <div class=\"bg-gray-10 margin-1\">\r\n            <div class=\"bg-gray-10 margin-2\">\r\n                <div class=\"grid-row\">\r\n                    <div class=\"tablet:grid-col display-flex flex-align-center flex-justify-center\">\r\n                        <div class=\"text-bold font-sans-2xl flex-align-center text-gray-50\">\r\n                            Preview\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"grid-row margin-bottom-1 margin-top-1\">\r\n                    <div class=\"tablet:grid-col\">\r\n                        {{templateTitle}}\r\n                    </div>\r\n                </div>\r\n                <div class=\"grid-row\">\r\n                    <div class=\"tablet:grid-col\">\r\n                        {{previewText}}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isEditMode\">\r\n        <textarea class=\"margin-left-2\" title=\"Comment\" placeholder=\"Write a comment\u2026\"\r\n            style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n            [(ngModel)]=\"previewText\" (ngModelChange)=\"editText($event)\" id=\"txtArea\" [maxlength]=\"maxCommentLength\"\r\n            [attr.rows]=\"25\" [attr.cols]=\"getTextAreaCol()\"></textarea>\r\n\r\n\r\n        <div class=\"grid-container margin-bottom-1\">\r\n            <div class=\"grid-row flex-column flex-align-end\">\r\n                <div class=\"grid-col flex-fill\">\r\n                    <div *ngIf=\"textLengthRemain>0\" class=\"pos-right\">\r\n                        {{textLengthRemain}} characters remaining\r\n                    </div>\r\n                    <div *ngIf=\"textLengthRemain===0\" class=\"pos-right\">\r\n                        Text truncated, {{textLengthRemain}} characters remaining\r\n                    </div>\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n    <div class=\"grid-container padding-0 padding-bottom-1\">\r\n        <div class=\"grid-row flex-column flex-align-end\">\r\n            <div class=\"grid-col flex-fill\">\r\n                <button class=\" pos-right usa-button usa-button--accent-cool\" (click)=\"cancel()\">Cancel</button>\r\n                <button *ngIf=\"!isEditMode\" class=\"pos-right usa-button usa-button--accent-cool\"\r\n                    [disabled]=\"!previewText\" (click)=\"insert()\">Insert</button>\r\n                <button *ngIf=\"isEditMode\" class=\"pos-right usa-button usa-button--accent-cool\"\r\n                    [disabled]=\"!previewText\" (click)=\"send()\">Send</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>" }]
        }], ctorParameters: () => [], propDecorators: { threadId: [{
                type: Input
            }], source: [{
                type: Input
            }], sourceId: [{
                type: Input
            }], role: [{
                type: Input
            }], showUser: [{
                type: Input
            }], service: [{
                type: Input
            }], templateService: [{
                type: Input
            }], maxCommentLength: [{
                type: Input
            }], templateSelected: [{
                type: Output
            }], windowSize: [{
                type: Input
            }] } });

class GenericThreadComponent {
    colapse() {
        this.expandTextBox = false;
    }
    expand() {
        this.expandTextBox = true;
    }
    constructor(threadService, dialog, toastr) {
        this.threadService = threadService;
        this.dialog = dialog;
        this.toastr = toastr;
        this.threadCreated = new EventEmitter();
        this.maxCommentLength = 500;
        this.windowSize = WindowSize.MIN;
        this.ThreadViewMode = ThreadViewMode;
        this.commentCount = 0;
        this.model = { commentField: '' };
        this.expandedText = false;
        this.expandTextBox = false;
    }
    ngAfterViewInit() {
        {
            if (this.serviceOveride) {
                this.service = this.serviceOveride;
            }
            else {
                this.service = this.threadService;
            }
            if (this.threadId) {
                this.getCommentCount();
            }
        }
    }
    insertTemplate() {
        this.mode = ThreadViewMode.TEMPLATE;
    }
    getCommentCount() {
        this.service.getCommentCount(this.threadId).subscribe((commentCount) => {
            this.commentCount = commentCount;
        }, err => {
            console.error(err);
        });
    }
    saveComment() {
        const comment = new CommentEntity(null, this.threadId, this.model.commentField, 'User', 'Last', 
        //undefined, undefined,
        this.role, this.showUser, new Date());
        this.service.createComment(comment, this.threadId).subscribe((comment) => {
            comment.createdByUser = true;
            this.comments.push(comment);
            this.commentCount = this.comments.length;
            this.model.commentField = '';
            this.toastr.success('Comment Saved', "");
        }, err => {
            console.error(err);
            this.toastr.error('Comment could not be saved. Please try again', "");
        });
    }
    deleteComment(comment) {
        const comment2 = comment;
        this.service.deleteComment(comment).subscribe((comment) => {
            this.comments = this.comments.filter(function (ele) {
                return ele.id != comment2.id;
            });
            this.commentCount = this.comments.length;
            this.toastr.success('Comment Deleted', "");
        }, err => {
            console.error(err);
            this.toastr.error('Comment could not be deleted. Please try again', "");
        });
        this.mode = ThreadViewMode.DEFAULT;
    }
    editComment(comment) {
        const comment2 = comment;
        this.service.editComment(comment, comment.id).subscribe((comment) => {
            const commentFound = this.comments.find(element => element.id === comment2.id);
            commentFound.comment = comment2.comment;
            this.toastr.success('Comment Updated', "");
        }, err => {
            console.error(err);
            this.toastr.error('Comment could not be updated. Please try again', "");
        });
    }
    buttonClicked() {
        if (!this.openedDialogRef) {
            this.mode = ThreadViewMode.DEFAULT;
            if (this.threadId) {
                this.getComments();
            }
            else {
                this.createNewThread();
            }
        }
        else {
            this.onCloseSlideOut();
        }
    }
    createNewThread() {
        const thread = new ThreadEntity(null, this.source, this.sourceId);
        this.service.createThread(thread).subscribe((threadRtn) => {
            this.threadId = threadRtn.id;
            this.comments = [];
            this.commentCount = 0;
            this.openCloseSlideOut();
            this.threadCreated.emit(this.threadId);
        }, err => {
            console.error(err);
        });
    }
    getComments() {
        this.service.getComments(this.threadId).subscribe((comments) => {
            this.comments = comments;
            this.commentCount = comments.length;
            this.openCloseSlideOut();
        }, err => {
            console.error(err);
            this.toastr.error('Could not retrieve comments. Please try again', "");
        });
    }
    templateSelected(text) {
        this.mode = ThreadViewMode.DEFAULT;
        this.model.commentField = text;
        if (text && text.length > 0) {
            this.saveComment();
        }
    }
    onCloseSlideOut() {
        this.openedDialogRef.close();
        this.openedDialogRef = null;
    }
    windowSizeChange(windowSize) {
        if ([WindowSize.MAX, WindowSize.MID, WindowSize.MIN].indexOf(windowSize) !== -1) {
            this.windowSize = windowSize;
        }
        switch (this.windowSize) {
            case WindowSize.MAX:
                this.openedDialogRef._containerInstance._config.slideOut["width"] = window.innerWidth < 960 ? `${window.innerWidth}px` : "960px";
                break;
            case WindowSize.MID:
                this.openedDialogRef._containerInstance._config.slideOut["width"] = window.innerWidth < 640 ? `${window.innerWidth}px` : "640px";
                break;
            case WindowSize.MIN:
                this.openedDialogRef._containerInstance._config.slideOut["width"] = window.innerWidth < 320 ? `${window.innerWidth}px` : "320px";
                break;
            default:
                break;
        }
    }
    getTextAreaCol() {
        let colCount = 0;
        switch (this.windowSize) {
            case WindowSize.MAX:
                colCount = 118;
                break;
            case WindowSize.MID:
                colCount = 75;
                break;
            case WindowSize.MIN:
                colCount = 30;
                break;
            default:
                break;
        }
        return colCount;
    }
    openCloseSlideOut() {
        this.model.commentField = "";
        this.openedDialogRef = this.dialog.open(this.ref, {
            hasBackdrop: false,
            height: '100%',
            position: { right: 'true' },
            slideOut: {
                width: '20rem',
                time: '350ms',
            },
            displayCloseBtn: false,
        });
    }
    showMoreShowLess(showMoreLessData) {
        if (showMoreLessData.showMore) {
            this.mode = ThreadViewMode.VIEW;
        }
        else {
            this.mode = ThreadViewMode.DEFAULT;
        }
        this.comment = showMoreLessData.comment;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadComponent, deps: [{ token: GenericThreadService }, { token: i2.SdsDialogService }, { token: i3$1.ToastrService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: GenericThreadComponent, selector: "thread", inputs: { threadId: "threadId", source: "source", sourceId: "sourceId", role: "role", showUser: "showUser", disabledAddComments: "disabledAddComments", disabledEditComments: "disabledEditComments", disabledDeleteComments: "disabledDeleteComments", serviceOveride: "serviceOveride", templateService: "templateService", maxCommentLength: "maxCommentLength", windowSize: "windowSize" }, outputs: { threadCreated: "threadCreated" }, host: { listeners: { "window:resize": "windowSizeChange($event)" } }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["templateRef"], descendants: true }], ngImport: i0, template: "<button\r\n  [class]=\"!openedDialogRef ? 'usa-button usa-button--outline usa-button bg-primary-lighter':'usa-button usa-button--outline usa-button bg-primary-lighter usa-button--active' \"\r\n  (click)=\"buttonClicked()\">\r\n\r\n  <usa-icon class=\"padding-right-05\" [icon]=\"'chat-left-dots'\" [size]=\"'x'\">\r\n  </usa-icon>\r\n  <span>Comments ({{commentCount}})</span>\r\n</button>\r\n\r\n<ng-template #templateRef>\r\n  <div class=\"container\" role=\"dialog\" aria-labelledby=\"slide-out-title\" cdkTrapFocus>\r\n    <div class=\" bg-secondary-vivid padding-1\">\r\n      <h2 class=\"text-base-lightest  font-sans-md\" id=\"slide-out-title\">Comments ({{commentCount}})</h2>\r\n      <button sds-dialog-close (click)=\"onCloseSlideOut()\" class=\"close-btn pin-top\" aria-label=\"Close Modal\">\r\n        <usa-icon class=\"text-base-lightest\" size=\"2x\" [icon]=\"'x'\"></usa-icon>\r\n      </button>\r\n    </div>\r\n    <div class=\"content\">\r\n      <window-size (windowSizeChange)=\"windowSizeChange($event)\"></window-size>\r\n      <div class=\"bg-base-lighter\" *ngIf=\"mode===ThreadViewMode.DEFAULT\">\r\n        <!--Comment Boxes-->\r\n        <div *ngFor=\"let comment of comments\">\r\n          <comment [windowSize]=\"windowSize\" [comment]=\"comment\" (editCommentEvent)=\"editComment($event)\" [maxCommentLength]=\"maxCommentLength\"\r\n            (showMoreShowLess)=\"showMoreShowLess($event)\" (deleteCommentEvent)=\"deleteComment($event)\"\r\n            [disabledDeleteComments]=\"disabledDeleteComments\" [disabledEditComments]=\"disabledEditComments\"></comment>\r\n        </div>\r\n      </div>\r\n      <div class=\"padding-top-1\">\r\n        <!--Bottom Fields-->\r\n        <div *ngIf=\"!disabledAddComments && mode===ThreadViewMode.DEFAULT\"\r\n          class=\"grid-container  padding-2px  bg-base-lightest \">\r\n          <div class=\"grid-row grid-gap-2px\">\r\n            <div classs=\"grid-col flex-auto\">\r\n              <textarea class=\"padding-left-1\" title=\"Comment\" placeholder=\"Write a comment\u2026\"\r\n                style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n                [(ngModel)]=\"model.commentField\" id=\"txtArea\" [maxlength]=\"maxCommentLength\"\r\n                [attr.rows]=\"expandTextBox?10:5\" [attr.cols]=\"getTextAreaCol()\"></textarea>\r\n            </div>\r\n            <div classs=\"grid-col flex-auto\">\r\n              <!--Expand Collapse Textarea-->\r\n              <button title=\"Expand Comment Field\" *ngIf=\"!expandTextBox\" (click)=\"expand()\"\r\n                class=\"usa-button usa-button--unstyled\">\r\n                <usa-icon [icon]=\"'chevron-up'\" [size]=\"'2x'\">\r\n                </usa-icon>\r\n              </button>\r\n              <button title=\"Colapse Comment Field\" *ngIf=\"expandTextBox\" (click)=\"colapse()\"\r\n                class=\"usa-button usa-button--unstyled\">\r\n                <usa-icon [icon]=\"'chevron-down'\" [size]=\"'2x'\">\r\n                </usa-icon>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div>\r\n\r\n            <div class=\"grid-row flex-column flex-align-end\">\r\n              <div classs=\"grid-col flex-fill\">\r\n                <button *ngIf=\"templateService\" (click)=\"insertTemplate()\"\r\n                  class=\"pos-right usa-button usa-button--accent-cool\">Insert Template</button>\r\n                <button [disabled]=\" !model.commentField\" (click)=\"saveComment()\"\r\n                  class=\"pos-right usa-button usa-button--accent-cool\">Send</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"mode===ThreadViewMode.TEMPLATE\">\r\n      <template-view [windowSize]=\"windowSize\" [maxCommentLength]=\"maxCommentLength\" (templateSelected)=\"templateSelected($event)\"\r\n        [templateService]=\"templateService\"></template-view>\r\n    </div>\r\n\r\n\r\n    <div class=\"bg-base-lighter\" *ngIf=\"mode===ThreadViewMode.VIEW\">\r\n      <comment [windowSize]=\"windowSize\" [comment]=\"comment\" [showMore]=\"true\" (editCommentEvent)=\"editComment($event)\"\r\n        [maxCommentLength]=\"maxCommentLength\" (deleteCommentEvent)=\"deleteComment($event)\"\r\n        (showMoreShowLess)=\"showMoreShowLess($event)\" [disabledDeleteComments]=\"disabledDeleteComments\"\r\n        [disabledEditComments]=\"disabledEditComments\"></comment>\r\n    </div>\r\n  </div>\r\n\r\n</ng-template>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$1.IconComponent, selector: "usa-icon", inputs: ["icon", "rotate", "size", "classes", "skew"] }, { kind: "component", type: CommentComponent, selector: "comment", inputs: ["showMore", "comment", "disabledEditComments", "disabledDeleteComments", "maxCommentLength", "windowSize"], outputs: ["deleteCommentEvent", "editCommentEvent", "showMoreShowLess"] }, { kind: "component", type: TemplateViewComponent, selector: "template-view", inputs: ["threadId", "source", "sourceId", "role", "showUser", "service", "templateService", "maxCommentLength", "windowSize"], outputs: ["templateSelected"] }, { kind: "component", type: WindowSizeComponent, selector: "window-size", outputs: ["windowSizeChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'thread', template: "<button\r\n  [class]=\"!openedDialogRef ? 'usa-button usa-button--outline usa-button bg-primary-lighter':'usa-button usa-button--outline usa-button bg-primary-lighter usa-button--active' \"\r\n  (click)=\"buttonClicked()\">\r\n\r\n  <usa-icon class=\"padding-right-05\" [icon]=\"'chat-left-dots'\" [size]=\"'x'\">\r\n  </usa-icon>\r\n  <span>Comments ({{commentCount}})</span>\r\n</button>\r\n\r\n<ng-template #templateRef>\r\n  <div class=\"container\" role=\"dialog\" aria-labelledby=\"slide-out-title\" cdkTrapFocus>\r\n    <div class=\" bg-secondary-vivid padding-1\">\r\n      <h2 class=\"text-base-lightest  font-sans-md\" id=\"slide-out-title\">Comments ({{commentCount}})</h2>\r\n      <button sds-dialog-close (click)=\"onCloseSlideOut()\" class=\"close-btn pin-top\" aria-label=\"Close Modal\">\r\n        <usa-icon class=\"text-base-lightest\" size=\"2x\" [icon]=\"'x'\"></usa-icon>\r\n      </button>\r\n    </div>\r\n    <div class=\"content\">\r\n      <window-size (windowSizeChange)=\"windowSizeChange($event)\"></window-size>\r\n      <div class=\"bg-base-lighter\" *ngIf=\"mode===ThreadViewMode.DEFAULT\">\r\n        <!--Comment Boxes-->\r\n        <div *ngFor=\"let comment of comments\">\r\n          <comment [windowSize]=\"windowSize\" [comment]=\"comment\" (editCommentEvent)=\"editComment($event)\" [maxCommentLength]=\"maxCommentLength\"\r\n            (showMoreShowLess)=\"showMoreShowLess($event)\" (deleteCommentEvent)=\"deleteComment($event)\"\r\n            [disabledDeleteComments]=\"disabledDeleteComments\" [disabledEditComments]=\"disabledEditComments\"></comment>\r\n        </div>\r\n      </div>\r\n      <div class=\"padding-top-1\">\r\n        <!--Bottom Fields-->\r\n        <div *ngIf=\"!disabledAddComments && mode===ThreadViewMode.DEFAULT\"\r\n          class=\"grid-container  padding-2px  bg-base-lightest \">\r\n          <div class=\"grid-row grid-gap-2px\">\r\n            <div classs=\"grid-col flex-auto\">\r\n              <textarea class=\"padding-left-1\" title=\"Comment\" placeholder=\"Write a comment\u2026\"\r\n                style=\"resize: none; border-style: none; border-color: Transparent; overflow: auto; \"\r\n                [(ngModel)]=\"model.commentField\" id=\"txtArea\" [maxlength]=\"maxCommentLength\"\r\n                [attr.rows]=\"expandTextBox?10:5\" [attr.cols]=\"getTextAreaCol()\"></textarea>\r\n            </div>\r\n            <div classs=\"grid-col flex-auto\">\r\n              <!--Expand Collapse Textarea-->\r\n              <button title=\"Expand Comment Field\" *ngIf=\"!expandTextBox\" (click)=\"expand()\"\r\n                class=\"usa-button usa-button--unstyled\">\r\n                <usa-icon [icon]=\"'chevron-up'\" [size]=\"'2x'\">\r\n                </usa-icon>\r\n              </button>\r\n              <button title=\"Colapse Comment Field\" *ngIf=\"expandTextBox\" (click)=\"colapse()\"\r\n                class=\"usa-button usa-button--unstyled\">\r\n                <usa-icon [icon]=\"'chevron-down'\" [size]=\"'2x'\">\r\n                </usa-icon>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div>\r\n\r\n            <div class=\"grid-row flex-column flex-align-end\">\r\n              <div classs=\"grid-col flex-fill\">\r\n                <button *ngIf=\"templateService\" (click)=\"insertTemplate()\"\r\n                  class=\"pos-right usa-button usa-button--accent-cool\">Insert Template</button>\r\n                <button [disabled]=\" !model.commentField\" (click)=\"saveComment()\"\r\n                  class=\"pos-right usa-button usa-button--accent-cool\">Send</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"mode===ThreadViewMode.TEMPLATE\">\r\n      <template-view [windowSize]=\"windowSize\" [maxCommentLength]=\"maxCommentLength\" (templateSelected)=\"templateSelected($event)\"\r\n        [templateService]=\"templateService\"></template-view>\r\n    </div>\r\n\r\n\r\n    <div class=\"bg-base-lighter\" *ngIf=\"mode===ThreadViewMode.VIEW\">\r\n      <comment [windowSize]=\"windowSize\" [comment]=\"comment\" [showMore]=\"true\" (editCommentEvent)=\"editComment($event)\"\r\n        [maxCommentLength]=\"maxCommentLength\" (deleteCommentEvent)=\"deleteComment($event)\"\r\n        (showMoreShowLess)=\"showMoreShowLess($event)\" [disabledDeleteComments]=\"disabledDeleteComments\"\r\n        [disabledEditComments]=\"disabledEditComments\"></comment>\r\n    </div>\r\n  </div>\r\n\r\n</ng-template>" }]
        }], ctorParameters: () => [{ type: GenericThreadService }, { type: i2.SdsDialogService }, { type: i3$1.ToastrService }], propDecorators: { threadId: [{
                type: Input
            }], source: [{
                type: Input
            }], sourceId: [{
                type: Input
            }], role: [{
                type: Input
            }], showUser: [{
                type: Input
            }], disabledAddComments: [{
                type: Input
            }], disabledEditComments: [{
                type: Input
            }], disabledDeleteComments: [{
                type: Input
            }], serviceOveride: [{
                type: Input
            }], threadCreated: [{
                type: Output
            }], templateService: [{
                type: Input
            }], maxCommentLength: [{
                type: Input
            }], ref: [{
                type: ViewChild,
                args: ['templateRef']
            }], windowSize: [{
                type: Input
            }], windowSizeChange: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });
var ThreadViewMode;
(function (ThreadViewMode) {
    ThreadViewMode[ThreadViewMode["TEMPLATE"] = 0] = "TEMPLATE";
    ThreadViewMode[ThreadViewMode["VIEW"] = 1] = "VIEW";
    ThreadViewMode[ThreadViewMode["DEFAULT"] = 2] = "DEFAULT";
})(ThreadViewMode || (ThreadViewMode = {}));

const middle_window_blue = "<svg width=\"37px\" height=\"40.8275862px\" viewBox=\"0 0 37 40.8275862\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-302.000000, -142.000000)\"><g id=\"Group-44\" transform=\"translate(302.000000, 142.000000)\"><rect id=\"Rectangle-Copy\" stroke=\"#2672DE\" fill=\"#D9E8F6\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"39.8275862\" rx=\"5\"></rect><rect id=\"Rectangle-Copy-6\" fill=\"#2672DE\" x=\"15.3103448\" y=\"5.10344828\" width=\"16.5862069\" height=\"30.6206897\" rx=\"2\"></rect></g></g></g></svg>";
const middle_window_grey = "<svg width=\"37px\" height=\"40.8275862px\" viewBox=\"0 0 37 40.8275862\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"37\" height=\"40.8275862\" rx=\"5\"></rect><filter x=\"-4.1%\" y=\"-3.7%\" width=\"108.1%\" height=\"107.3%\" filterUnits=\"objectBoundingBox\" id=\"filter-2\"><feGaussianBlur stdDeviation=\"1.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur><feOffset dx=\"0\" dy=\"0\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset><feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite><feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix></filter></defs><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-302.000000, -189.000000)\"><g id=\"Group-8\" transform=\"translate(302.000000, 189.000000)\"><g id=\"Rectangle-Copy\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-2)\" xlink:href=\"#path-1\"></use><rect stroke=\"#C9C9C9\" stroke-width=\"1\" stroke-linejoin=\"square\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"39.8275862\" rx=\"5\"></rect></g><rect id=\"Rectangle-Copy-6\" fill=\"#C9C9C9\" x=\"15.3103448\" y=\"5.10344828\" width=\"16.5862069\" height=\"30.6206897\" rx=\"2\"></rect></g></g></g></svg>";
const narrow_window_blue = "<svg width=\"37px\" height=\"41px\" viewBox=\"0 0 37 41\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-249.000000, -142.000000)\"><g id=\"Group-6\" transform=\"translate(249.000000, 142.000000)\"><rect id=\"Rectangle\" stroke=\"#2672DE\" fill=\"#D9E8F6\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"40\" rx=\"5\"></rect><rect id=\"Rectangle\" fill=\"#2672DE\" x=\"22\" y=\"5\" width=\"10\" height=\"31\" rx=\"2\"></rect></g></g></g></svg>";
const narrow_window_grey = "<svg width=\"37px\" height=\"41px\" viewBox=\"0 0 37 41\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"37\" height=\"41\" rx=\"5\"></rect><filter x=\"-4.1%\" y=\"-3.7%\" width=\"108.1%\" height=\"107.3%\" filterUnits=\"objectBoundingBox\" id=\"filter-2\"><feGaussianBlur stdDeviation=\"1.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur><feOffset dx=\"0\" dy=\"0\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset><feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite><feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix></filter></defs><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-249.000000, -189.000000)\"><g id=\"Group-7\" transform=\"translate(249.000000, 189.000000)\"><g id=\"Rectangle-Copy-3\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-2)\" xlink:href=\"#path-1\"></use><rect stroke=\"#C9C9C9\" stroke-width=\"1\" stroke-linejoin=\"square\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"40\" rx=\"5\"></rect></g><rect id=\"Rectangle-Copy-4\" fill=\"#C9C9C9\" x=\"22\" y=\"5\" width=\"10\" height=\"31\" rx=\"2\"></rect></g></g></g></svg>";
const wide_window_blue = "<svg width=\"37px\" height=\"40.8275862px\" viewBox=\"0 0 37 40.8275862\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-355.000000, -142.000000)\"><g id=\"Group-5\" transform=\"translate(355.000000, 142.000000)\"><rect id=\"Rectangle-Copy-2\" stroke=\"#2672DE\" fill=\"#D9E8F6\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"39.8275862\" rx=\"5\"></rect><rect id=\"Rectangle-Copy-6\" fill=\"#2672DE\" x=\"8.0928382\" y=\"5.10344828\" width=\"24\" height=\"30.6206897\" rx=\"2\"></rect></g></g></g></svg>";
const wide_window_grey = "<svg width=\"37px\" height=\"40.8275862px\" viewBox=\"0 0 37 40.8275862\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"37\" height=\"40.8275862\" rx=\"5\"></rect><filter x=\"-4.1%\" y=\"-3.7%\" width=\"108.1%\" height=\"107.3%\" filterUnits=\"objectBoundingBox\" id=\"filter-2\"><feGaussianBlur stdDeviation=\"1.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur><feOffset dx=\"0\" dy=\"0\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset><feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite><feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix></filter></defs><g id=\"Expand-&amp;-Collapse-Comments\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Slide-Out/01-Base/C2\" transform=\"translate(-355.000000, -189.000000)\"><g id=\"Group-10\" transform=\"translate(355.000000, 189.000000)\"><g id=\"Rectangle-Copy-5\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-2)\" xlink:href=\"#path-1\"></use><rect stroke=\"#C9C9C9\" stroke-width=\"1\" stroke-linejoin=\"square\" x=\"0.5\" y=\"0.5\" width=\"36\" height=\"39.8275862\" rx=\"5\"></rect></g><rect id=\"Rectangle-Copy-7\" fill=\"#C9C9C9\" x=\"8.0928382\" y=\"5.10344828\" width=\"24\" height=\"30.6206897\" rx=\"2\"></rect></g></g></g></svg>";
const group_8_login_gov_icon = "<svg width=\"12.9839416px\" height=\"16.5px\" viewBox=\"0 0 12.9839416 16.5\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group 8login_gov_icon</title><defs><polygon id=\"path-1\" points=\"0 0 6.49381071 0 6.49381071 16.5 0 16.5\"></polygon></defs><g id=\"Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Home----Desktop-Copy-7\" transform=\"translate(-763.033, -267.25)\"><g id=\"Group-8\" transform=\"translate(763.033, 267.25)\"><g id=\"Group-3\" transform=\"translate(6.4901, 0)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-2\"></g><path d=\"M4.67892857,0 L0,0 L0,16.5 C4.43928571,14.5357143 5.99107143,11.99 6.38392857,11.1964286 C6.45778571,11.0447857 6.4955,10.8778214 6.49397574,10.7092857 L6.49397574,1.815 C6.49397574,0.812428571 5.68110714,0 4.67892857,0\" id=\"Fill-1\" fill=\"#B51E23\" mask=\"url(#mask-2)\"></path></g><path d=\"M1.81504717,0 C0.812475739,0 0,0.812428571 0,1.815 L0,10.7092857 C-0.00152426054,10.8782143 0.0361900252,11.0447857 0.110047168,11.1964286 C0.502904311,11.9821429 2.07433288,14.5475 6.49004717,16.5 L6.49004717,0 L1.81504717,0 Z\" id=\"Fill-4\" fill=\"#E21D3E\"></path><path d=\"M7.64115788,7.11075357 C8.44101503,6.48139643 8.57890788,5.32325357 7.9499436,4.52339643 C7.32058645,3.72353929 6.16205074,3.58525357 5.36258645,4.21461071 C4.56272931,4.843575 4.4244436,6.00211071 5.05380074,6.80196786 C5.14415788,6.91668214 5.24787217,7.02039643 5.36258645,7.11075357 C5.15830074,8.26575357 4.95676503,9.42075357 4.75758645,10.5757536 C5.32958645,10.6743607 5.9094436,10.7242536 6.49008645,10.7250393 C7.07937217,10.736825 7.66787217,10.6975393 8.25008645,10.6071821 C8.04580074,9.42861071 7.85722931,8.27361071 7.64115788,7.11075357\" id=\"Fill-6\" fill=\"#FFFFFF\"></path></g></g></g></g></g></svg>";

class GenericThreadModule {
    static forRoot(config) {
        return {
            ngModule: GenericThreadModule,
            providers: [
                { provide: SystemConfig, useValue: config }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadModule, declarations: [GenericThreadComponent,
            CommentComponent,
            TemplateViewComponent,
            WindowSizeComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule, i1$4.FormlyModule, SdsFormlyModule,
            SdsToastModule, i3$1.ToastrModule, IconModule,
            HttpClientModule, i1$2.NgxBootstrapIconsModule, SdsAutocompleteModule], exports: [GenericThreadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadModule, providers: [GenericThreadService, ToastrService], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule,
            FormlyModule.forChild({
                wrappers: [],
            }),
            SdsFormlyModule,
            SdsToastModule,
            ToastrModule.forRoot(SdsToastSettings),
            IconModule,
            HttpClientModule,
            NgxBootstrapIconsModule.pick({ middle_window_blue, middle_window_grey, narrow_window_blue, narrow_window_grey, wide_window_blue, wide_window_grey, chevronDown, chevronUp, chatLeftDots, group_8_login_gov_icon }),
            SdsAutocompleteModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: GenericThreadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GenericThreadComponent,
                        CommentComponent,
                        TemplateViewComponent,
                        WindowSizeComponent,
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        FormlyModule.forChild({
                            wrappers: [],
                        }),
                        SdsFormlyModule,
                        SdsToastModule,
                        ToastrModule.forRoot(SdsToastSettings),
                        IconModule,
                        HttpClientModule,
                        NgxBootstrapIconsModule.pick({ middle_window_blue, middle_window_grey, narrow_window_blue, narrow_window_grey, wide_window_blue, wide_window_grey, chevronDown, chevronUp, chatLeftDots, group_8_login_gov_icon }),
                        SdsAutocompleteModule,
                    ],
                    exports: [
                        GenericThreadComponent
                    ],
                    providers: [GenericThreadService, ToastrService]
                }]
        }] });

var Alert;
(function (Alert) {
    Alert["warning"] = "warning";
    Alert["info"] = "info";
    Alert["error"] = "error";
    Alert["success"] = "success";
})(Alert || (Alert = {}));
class TermsOfServiceComponent {
    constructor(authService, dialog, router) {
        this.authService = authService;
        this.dialog = dialog;
        this.router = router;
    }
    ngAfterViewInit() {
        // If user changes email in login.gov and tries to login to sam.gov with
        // new email check if new email domain is diffenent
        const newEmailDoesNotMatchPreviousEmailDomain = (queryParams) => {
            return !!(queryParams.loginintercept && queryParams.loginintercept === '1004');
        };
        this.router.events
            .pipe(filter((event) => !!event && event instanceof RoutesRecognized), map((event) => event.state.root.queryParams), map(newEmailDoesNotMatchPreviousEmailDomain))
            .subscribe((changedEmailDoesNotHaveTheSameEmailDomain) => {
            if (changedEmailDoesNotHaveTheSameEmailDomain) {
                return;
            }
            this.authService.checkSession().subscribe((res) => {
                if (res.isProfileComplete && res.isUatSigned === false) {
                    //Navitgate
                    this.dialog.open(TermsOfServiceModalComponent, {
                        width: 'medium',
                        alert: Alert.info,
                        displayCloseBtn: false,
                        disableClose: true,
                    });
                }
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceComponent, deps: [{ token: i1$3.AuthService }, { token: i2.SdsDialogService }, { token: i5.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TermsOfServiceComponent, selector: "terms-of-service", ngImport: i0, template: ``, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceComponent, decorators: [{
            type: Component,
            args: [{
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: 'terms-of-service',
                    template: ``,
                }]
        }], ctorParameters: () => [{ type: i1$3.AuthService }, { type: i2.SdsDialogService }, { type: i5.Router }] });
class TermsOfServiceModalComponent {
    constructor(config, http, authService, dialog) {
        this.config = config;
        this.http = http;
        this.authService = authService;
        this.dialog = dialog;
        this.agreeCheckbox = false;
    }
    saveResponse() {
        const headers = {
            'X-Auth-Token': this.authService.authToken(),
        };
        const url = `${this.config.apiUrl}/rms/v1/agreements`;
        this.http.post(url, { type: 'ty7NM1Flgx' }, { headers }).subscribe(() => {
            this.dialog.closeAll();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModalComponent, deps: [{ token: i1$3.SystemConfigHeader, optional: true }, { token: i1.HttpClient }, { token: i1$3.AuthService }, { token: i2.SdsDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.5", type: TermsOfServiceModalComponent, selector: "terms-of-service-modal", ngImport: i0, template: `
    <div sds-dialog-title>Complete Your Profile</div>
    <div sds-dialog-content>
      <p style="font-size: 20px">
        You must agree to our terms for accessing the site.
      </p>
      <h2 class="text-semibold margin-top-2">SAM.gov User Access Terms</h2>
      <ul class="text-left font-body-xs line-height-sans-3 margin-bottom-0">
        <li class="margin-bottom-105">
          The login.gov account I created is associated with my own personal
          email address or an email address controlled by my entity.
        </li>
        <li class="margin-bottom-105">
          I am agreeing to these terms on my own behalf and I am not
          representing someone else nor agreeing to the terms on their behalf.
        </li>
        <li class="margin-bottom-105">
          I will not access SAM.gov with someone else’s login.gov account,
          including someone else in my entity.
        </li>
        <li class="margin-bottom-105">
          I will not share my login.gov account password with anyone else for
          any reason, including other people in my entity.
        </li>
        <li>
          If I fail to follow these user access terms, my SAM.gov account may be
          disabled and I may lose access to SAM.gov.
        </li>
      </ul>

      <div class="usa-checkbox font-body-xs text-left">
        <input
          cdkFocusInitial
          [(ngModel)]="agreeCheckbox"
          class="usa-checkbox__input"
          type="checkbox"
          name="agree"
          id="agree"
        />
        <label
          class="usa-checkbox__label text-semibold  line-height-sans-3"
          for="agree"
        >
          I agree to the SAM.gov User Access Terms and all Login.gov terms of
          service as a condition of accessing SAM.gov.
        </label>
      </div>
    </div>
    <div sds-dialog-actions>
      <button
        class="usa-button"
        (click)="saveResponse()"
        [disabled]="!agreeCheckbox"
      >
        Submit
      </button>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2.SdsDialogTitleDirective, selector: "[sds-dialog-title], [sdsDialogTitle]", inputs: ["id"], exportAs: ["sdsDialogTitle"] }, { kind: "directive", type: i2.SdsDialogContentDirective, selector: "[sds-dialog-content], sds-dialog-content, [sdsDialogContent]" }, { kind: "directive", type: i2.SdsDialogActionsDirective, selector: "[sds-dialog-actions], sds-dialog-actions, [sdsDialogActions]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModalComponent, decorators: [{
            type: Component,
            args: [{
                    // eslint-disable-next-line @angular-eslint/component-selector
                    selector: 'terms-of-service-modal',
                    template: `
    <div sds-dialog-title>Complete Your Profile</div>
    <div sds-dialog-content>
      <p style="font-size: 20px">
        You must agree to our terms for accessing the site.
      </p>
      <h2 class="text-semibold margin-top-2">SAM.gov User Access Terms</h2>
      <ul class="text-left font-body-xs line-height-sans-3 margin-bottom-0">
        <li class="margin-bottom-105">
          The login.gov account I created is associated with my own personal
          email address or an email address controlled by my entity.
        </li>
        <li class="margin-bottom-105">
          I am agreeing to these terms on my own behalf and I am not
          representing someone else nor agreeing to the terms on their behalf.
        </li>
        <li class="margin-bottom-105">
          I will not access SAM.gov with someone else’s login.gov account,
          including someone else in my entity.
        </li>
        <li class="margin-bottom-105">
          I will not share my login.gov account password with anyone else for
          any reason, including other people in my entity.
        </li>
        <li>
          If I fail to follow these user access terms, my SAM.gov account may be
          disabled and I may lose access to SAM.gov.
        </li>
      </ul>

      <div class="usa-checkbox font-body-xs text-left">
        <input
          cdkFocusInitial
          [(ngModel)]="agreeCheckbox"
          class="usa-checkbox__input"
          type="checkbox"
          name="agree"
          id="agree"
        />
        <label
          class="usa-checkbox__label text-semibold  line-height-sans-3"
          for="agree"
        >
          I agree to the SAM.gov User Access Terms and all Login.gov terms of
          service as a condition of accessing SAM.gov.
        </label>
      </div>
    </div>
    <div sds-dialog-actions>
      <button
        class="usa-button"
        (click)="saveResponse()"
        [disabled]="!agreeCheckbox"
      >
        Submit
      </button>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.SystemConfigHeader, decorators: [{
                    type: Optional
                }] }, { type: i1.HttpClient }, { type: i1$3.AuthService }, { type: i2.SdsDialogService }] });

class TermsOfServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModule, declarations: [TermsOfServiceComponent, TermsOfServiceModalComponent], imports: [FormsModule, SdsDialogModule], exports: [TermsOfServiceComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModule, imports: [FormsModule, SdsDialogModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.5", ngImport: i0, type: TermsOfServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, SdsDialogModule],
                    exports: [TermsOfServiceComponent],
                    declarations: [TermsOfServiceComponent, TermsOfServiceModalComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CommentEntity, FooterComponent, FooterModule, GenericThreadComponent, GenericThreadModule, GenericThreadService, HeaderComponent, HeaderHelpService, HeaderModule, SignInWorkflowService, SystemAlertComponent, SystemAlertModule, SystemBusyModalComponent, SystemBusyModalConfig, TermsOfServiceComponent, TermsOfServiceModalComponent, TermsOfServiceModule, ThreadEntity, ThreadViewMode };
